class ZitamineAPI {
    #QUIZ_ENDPOINT_PREFIX = "https://api.zitamine.ro/api/quiz";
    #storage = new ZitamineData("ZitamineQuiz", true);
    #utmUrl = null; // Replace localStorage usage

    constructor(quiz_endpoint_url_prefix) {
        if (quiz_endpoint_url_prefix !== undefined) {
            this.#QUIZ_ENDPOINT_PREFIX = quiz_endpoint_url_prefix;
        }
        // Get UTM from storage instead of localStorage
        this.#utmUrl = this.#storage.utmUrl || null;
    }

    async checkUserStatus(emailAddress) {
        var url = this.#QUIZ_ENDPOINT_PREFIX.concat("/user/status/", emailAddress);
        if (this.#utmUrl) {
            url = url.concat("&reference=", encodeURIComponent(this.#utmUrl));
        }
        const response = await fetch(url, {
            credentials: "omit",
            method: "GET",
            mode: "cors",
        });
        const status = await response.json();
        return status;
    }

    async startNewQuiz(emailAddress, firstName, el = false) {
        var LastFinishedQuizKey = null;
        var profile = 0;
        if (el && el.getAttribute("profile")) {
            var profile = el.getAttribute("profile");
        }
        if (el && el.getAttribute("LastFinishedQuizKey")) {
            var LastFinishedQuizKey = el.getAttribute("LastFinishedQuizKey");
        }
        const request = {
            Email: emailAddress,
            FirstName: firstName,
            ProfileId: profile,
        };
        var url = this.#QUIZ_ENDPOINT_PREFIX.concat("/start");
        if (this.#utmUrl) {
            url = url.concat("?reference=", this.#utmUrl);
        }
        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(request),
            method: "POST",
        });
        const nextQuestionModel = await response.json();
        return nextQuestionModel;
    }

    nextQuestionURL() {
        var url = this.#QUIZ_ENDPOINT_PREFIX.concat("/question");
        if (this.#utmUrl) {
            url = url.concat("?reference=", this.#utmUrl);
        }
        return url;
    }

    async nextQuestion(nextQuestionModel) {
        if (!Array.isArray(nextQuestionModel)) {
            nextQuestionModel = [nextQuestionModel];
        }
        const url = this.nextQuestionURL();
        const request = nextQuestionModel;
        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(request),
            method: "POST",
        });
        const question = await response.json();

        // Set focus on text inputs after DOM updates
        if (typeof jQuery !== 'undefined') {
            jQuery(".zq-next-link").click(function () {
                setTimeout(function () {
                    jQuery(".zq-field input[type=text]").focus();
                }, 1000);
            });
        }
        return question;
    }

getResultsURL(testKey) {
    if (testKey) {
        // Store testKey in storage
        this.#storage.testKey = testKey;
        console.log('💾 Stored testKey in getResultsURL:', testKey);
    }
    
    // Call clearcart if it exists
    if (typeof clearcart === 'function') {
        clearcart();
    }
    
    var url = "https://api.zitamine.ro/api/quiz/end/dictionary2/" + testKey;
    return url;
}

  generateBackToQuizUrl() {
    const testKey = this.#storage.testKey;
    if (testKey) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('testKey', testKey);
        return currentUrl.toString();
    }
    return window.location.href;
}
  

    async getResults(testKey) {
        const url = this.getResultsURL(testKey);
        const response = await fetch(url, {
            credentials: "omit",
            method: "GET",
            mode: "cors",
        });
        const results = await response.json();
        return results;
    }
}

class ZitamineQuiz extends ZitamineCommon {
    #QUIZ_ENDPOINT_PREFIX = "https://api.zitamine.ro/api/quiz";
    #MALWARE_SCAN_ENDPOINT = "https://api.zitamine.ro/api/malware-scan";

    #START_OPTION_START_OVER = 0;
    #START_OPTION_CONTINUE = 1;
    #START_OPTION_RESULTS = 2;
    #fileUploadedSuccessfully = false;

    #quizWrapperElement = document.body;
    #sectionTemplates = [];
    #quizResults = {};
    #history = [];
    #emailAddress = null;
    #firstName = null;
    #profile = null;
    #utm = null;
    #currentTemplateType = null;
    #uploadStatus = false;
    #uploadedFile = false;
    #storage = new ZitamineData("ZitamineQuiz", true);

    // Add the missing properties from ZitamineCommon
    #productSKUTable = null;
    #productSKUTableIsLoading = false;

    #api = new ZitamineAPI();
    #nextQuestionModels = [];

constructor(quizWrapperElement, emailAddress) {
    super();

    if (quizWrapperElement != undefined) {
        this.#quizWrapperElement = quizWrapperElement;
    }
    if (emailAddress !== undefined) {
        this.#storage.emailAddress = emailAddress;
    }

    // ENHANCED: Back navigation handling
    if (document.addEventListener) {
        // Use popstate event for back navigation
        window.addEventListener('popstate', (event) => {
            console.log('🔄 Popstate event detected', event.state);
            
            const searchParams = new URLSearchParams(window.location.search);
            
            if (searchParams.has("testKey")) {
                console.log('🔙 Back navigation with testKey detected');
                const testKey = searchParams.get("testKey");
                
                // Store testKey
                this.#storage.testKey = testKey;
                
                // IMPORTANT: Only show packages, don't add to cart
                this.showPackagesFromBackNavigation(testKey);
            } else if (event.state && event.state.testKey) {
                // Handle case where testKey is in history state
                console.log('🔙 Back navigation with testKey in state');
                const testKey = event.state.testKey;
                
                this.#storage.testKey = testKey;
                this.showPackagesFromBackNavigation(testKey);
            }
        });

        // Keep visibility change as backup
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                const searchParams = new URLSearchParams(window.location.search);
                if (searchParams.has("testKey")) {
                    console.log('🔄 Page visible again with testKey');
                    
                    // Check if packages are already showing
                    const packageContainer = document.querySelector('.package-selection-container');
                    if (!packageContainer) {
                        console.log('📦 Package selection not visible, showing packages...');
                        const testKey = searchParams.get("testKey");
                        this.#storage.testKey = testKey;
                        this.showPackagesFromBackNavigation(testKey);
                    }
                }
            }
        });
    }

    // Original event listeners...
    if (quizWrapperElement) {
        quizWrapperElement.addEventListener("submit", (e) => {
            e.preventDefault();
            const click = new MouseEvent("click", {
                view: window,
                bubbles: true,
                cancelable: true,
            });
            e.target
                .closest("form")
                .querySelector("[data-zitamine-quiz-next-button]")
                .dispatchEvent(click);
        });

        quizWrapperElement.addEventListener("click", (e) => {
            if (e.target.dataset.preventDefault !== undefined) e.preventDefault();

            if (e.target.dataset.zitamineQuizNextButton !== undefined) {
                if (
                    this.#quizWrapperElement.querySelector(
                        "[data-zitamine-quiz-section-template][data-zitamine-quiz-question-type-value=start]"
                    )
                ) {
                    this.startButtonClicked(e.target);
                } else if (
                    e.target.closest(
                        "[data-zitamine-quiz-section-template][data-zitamine-quiz-question-type-value=start-options]"
                    )
                ) {
                    this.startOptionClicked(e.target);
                } else {
                    this.nextButtonClicked(e.target);
                }
            }
            if (e.target.dataset.zitamineQuizPrevButton !== undefined) {
                this.prevButtonClicked(e.target);
            }
        });
    }

    this.start();
}
showPackagesFromBackNavigation(testKey) {
    console.log('🔙 BACK NAVIGATION: Showing packages only for testKey:', testKey);
    
    // Stop any ongoing processes
    this.hidePackageSelectionLoader();
    this.hideSuspenseLoading(); // Hide any existing suspense loading
    
    // Clear any timeouts
    if (this.packageSelectionTimeout) {
        clearTimeout(this.packageSelectionTimeout);
    }
    
    // Ensure UI is visible
    this.showUIElements();
    
    // Store testKey
    this.#storage.testKey = testKey;
    
    // Load results and show packages (without adding to cart) - NO SUSPENSE LOADING
    this.#api.getResults(testKey)
        .then((results) => {
            console.log('📊 Results loaded for back navigation:', results);
            
            // Store results
            this.#storage.quizResults = results;
            this.#storage.firstName = results.UserName || this.#storage.firstName;
            
            // CRITICAL: Show packages IMMEDIATELY (no suspense loading for back navigation)
            this.showPackageSelectionOnly(results);
            
        })
        .catch((error) => {
            console.error('❌ Failed to load results for back navigation:', error);
            
            // Try using stored results
            if (this.#storage.quizResults) {
                console.log('💾 Using stored results as fallback');
                this.showPackageSelectionOnly(this.#storage.quizResults);
            } else {
                console.log('❌ No results available, starting normal flow');
                this.showUIElements();
                this.normalStart();
            }
        });
}
showPackageSelectionOnly(results) {
    console.log('📦 SHOWING PACKAGE SELECTION ONLY (no cart operations)');
    
    // Ensure UI is visible but keep header/timer hidden
    if (typeof jQuery !== 'undefined') {
        jQuery(".loader").hide();
        jQuery(".zq-content").show();
        jQuery(".zq-footer").show();
        
        // Keep these hidden for package selection
        jQuery(".zq-header").hide();
        jQuery(".zq-timer").hide();
        jQuery(".timer-bar").hide();
        jQuery(".progress-bar").hide();
        jQuery(".zq-progressbar").hide();
        
        jQuery(".zq-content").css("visibility", "visible");
        jQuery(".zq-footer").css("visibility", "visible");
    }
    
    // Validate results
    if (!results || !results.Esential || !results.Optim || !results.Complet) {
        console.error('❌ Invalid package structure for back navigation:', results);
        // Fallback to cart if structure is invalid
        window.location.pathname = "/cart";
        return;
    }
    
    console.log('✅ Valid package structure, rendering selection...');
    
    // Clear any existing content
    const sectionTemplate = this.#quizWrapperElement.querySelector("[data-zitamine-quiz-section-template]");
    if (sectionTemplate) {
        sectionTemplate.innerHTML = '';
    }
    
    // Create and render package selection
    const packageQuestion = this.createPackageSelectionQuestion(results);
    this.renderPackageSelection(packageQuestion);
    
    console.log('🎯 Package selection rendered for back navigation');
}
  
resetToPackageSelection(testKey) {
    console.log('🔄 RESETTING TO PACKAGE SELECTION with testKey:', testKey);
    
    // Clear any ongoing timeouts
    if (this.packageSelectionTimeout) {
        clearTimeout(this.packageSelectionTimeout);
    }
    
    // Stop any loaders
    this.hidePackageSelectionLoader();
    
    // Force show UI elements
    this.showUIElements();
    
    // Clear quiz state
    this.#nextQuestionModels = [];
    
    // Store testKey
    this.#storage.testKey = testKey;
    
    // Load results and show package selection
    this.#api.getResults(testKey)
        .then((results) => {
            console.log('📊 Results loaded for back navigation:', results);
            
            // Store results and user info
            this.#storage.quizResults = results;
            this.#storage.firstName = results.UserName || this.#storage.firstName;
            
            // CRITICAL: Force package selection rendering
            setTimeout(() => {
                this.forceRenderPackageSelection(results);
            }, 100);
            
        })
        .catch((error) => {
            console.error('❌ Failed to load results for back navigation:', error);
            this.showUIElements();
            // Fallback: try to use stored results
            if (this.#storage.quizResults) {
                console.log('⚠️ Using stored results as fallback');
                setTimeout(() => {
                    this.forceRenderPackageSelection(this.#storage.quizResults);
                }, 100);
            } else {
                console.log('❌ No stored results, starting normal flow');
                this.normalStart();
            }
        });
}
  // NEW: Force render package selection
forceRenderPackageSelection(results) {
    console.log('🎯 FORCE RENDERING PACKAGE SELECTION');
    
    // Ensure UI is visible
    this.showUIElements();
    
    // Check for package structure
    if (results && results.Esential && results.Optim && results.Complet) {
        console.log('✅ Package structure valid, rendering...');
        
        // Clear any existing content in the quiz wrapper
        const sectionTemplate = this.#quizWrapperElement.querySelector("[data-zitamine-quiz-section-template]");
        if (sectionTemplate) {
            sectionTemplate.innerHTML = '';
        }
        
        // Create and render package selection
        const packageQuestion = this.createPackageSelectionQuestion(results);
        this.renderPackageSelection(packageQuestion);
        
        console.log('📦 Package selection rendered successfully');
    } else {
        console.error('❌ Invalid package structure:', results);
        // Fallback to cart
        window.location.pathname = "/cart";
    }
}
  
start() {
    console.log('🚀 Starting quiz...');
    this.#nextQuestionModels = [];
    let searchParams = new URLSearchParams(window.location.search);
    
    // Check for testKey in URL params (back from cart)
    if (searchParams.has("testKey")) {
        let testKey = searchParams.get("testKey");
        console.log('🔙 Starting with testKey from URL (back navigation):', testKey);
        
        // Store the testKey
        this.#storage.testKey = testKey;
        
        // Use the back navigation method (only shows packages)
        this.showPackagesFromBackNavigation(testKey);
        return;
    }
    
    // Check for stored testKey (page refresh or direct access)
    if (this.#storage.testKey) {
        console.log('💾 Starting with stored testKey:', this.#storage.testKey);
        
        // For stored testKey, also just show packages
        this.showPackagesFromBackNavigation(this.#storage.testKey);
        return;
    }
    
    // Normal start process (new quiz)
    console.log('🆕 Starting normal quiz flow');
    this.normalStart();
}


showPackageSelectionDirectly(results) {
    console.log('=== SHOWING PACKAGE SELECTION DIRECTLY (from quiz completion) ===');
    
    // This method is called when quiz is completed, not from back navigation
    this.showPackageSelectionOnly(results);
}
  
showUIElements() {
    console.log('🎨 Ensuring UI elements are visible');
    
    if (typeof jQuery !== 'undefined') {
        // Hide all loaders
        jQuery(".loader").hide();
        
        // Show main UI elements
        jQuery(".zq-header").css("display", "grid").show();
        jQuery(".zq-content").show();
        jQuery(".zq-footer").show();
        
        // Ensure they are actually visible
        jQuery(".zq-header").css("visibility", "visible");
        jQuery(".zq-content").css("visibility", "visible");
        jQuery(".zq-footer").css("visibility", "visible");
    }
    
    // Also ensure any package selection loader is hidden
    this.hidePackageSelectionLoader();
}

// 4. Separate normal start logic
normalStart() {
    console.log('🔄 Starting normal quiz flow');
    
    if (
        this.#storage.emailAddress === undefined ||
        this.#storage.emailAddress === null
    ) {
        this.startFromTheBeginning();
    } else {
        this.checkUserStatus(this.#storage.emailAddress, this.#storage.firstName);
    }
    
    // Ensure UI elements are visible
    this.showUIElements();
}

    fillTemplateValues(prefix, data) {
        const el = this.#quizWrapperElement;
        this.fillQuestionValues(el, data);
    }

    // RESTORED: Medical questions page with full file upload functionality
    fillMedicalQuestionsPage(data) {
        this.#uploadedFile = false;
        this.#fileUploadedSuccessfully = false;
        const el = document.querySelector("[data-zitamine-quiz-section-template]");

        // Clear the content of this element
        if (el) {
            el.innerHTML = "";
        }
        const contentContainer = document.createElement("div");
        contentContainer.setAttribute("data-zitamine-quiz-section-template", "");

        // Title
        const titleElement = document.createElement("h1");
        titleElement.textContent = "Opțional: adaugă rezultatele analizelor";
        titleElement.style.fontSize = "6.6rem";
        titleElement.style.lineHeight = "7.5rem";
        titleElement.style.fontFamily = "var(--font-heading-family)";
        titleElement.style.color = "#043B6C";
        titleElement.style.textAlign = "center";
        titleElement.style.display = "block";
        titleElement.style.marginBottom = "3.5rem";

        // Create a new paragraph element for the additional text
        const paragraphWithLink = document.createElement("p");
        paragraphWithLink.innerHTML = 'Ai la îndemână rezultatele analizelor tale de sânge? ' +
            'Le poți introduce în câmpurile de mai jos sau ' +
            '<a href="#fileUploadSection" class="upload-link">poți încărca</a> ' +
            'direct fișierul cu rezultatele.';

        // Style the paragraph similarly to the additional text element from the previous example
        paragraphWithLink.style.fontSize = "2rem";
        paragraphWithLink.style.lineHeight = "2.4rem";
        paragraphWithLink.style.fontFamily = "var(--font-body-family)";
        paragraphWithLink.style.color = "#043B6C";
        paragraphWithLink.style.textAlign = "center";
        paragraphWithLink.style.display = "block";
        paragraphWithLink.style.marginBottom = "2rem";
        paragraphWithLink.style.padding = "0 2rem";

        contentContainer.appendChild(titleElement);
        contentContainer.appendChild(paragraphWithLink);

        const adjustTitleForScreenSize = () => {
            const isMobile = window.innerWidth <= 768;
            titleElement.style.fontSize = isMobile ? "3rem" : "5.6rem";
            titleElement.style.lineHeight = isMobile ? "4.8rem" : "7.5rem";
        };

        const specialQuestion = data.find((question) => question.Id === 98);
        let errorMessage;
        if (specialQuestion) {
            const specialQuestionContainer = document.createElement("div");
            specialQuestionContainer.className = "zq-medical-question";
            specialQuestionContainer.style.display = "flex";
            specialQuestionContainer.style.flexDirection = "column";
            specialQuestionContainer.style.alignItems = "flex-start";

            const bulletTextContainer = document.createElement("div");
            bulletTextContainer.style.display = "flex";
            bulletTextContainer.style.alignItems = "baseline";

            const bullet = document.createElement("div");
            bullet.style.display = "flex";
            bullet.style.width = "40px";
            bullet.style.height = "40px";
            bullet.style.padding = "10.5px 19.5px";
            bullet.style.justifyContent = "center";
            bullet.style.alignItems = "center";
            bullet.style.borderRadius = "100px";
            bullet.style.background = "var(--Indigo, #043B6C)";
            bullet.style.marginRight = "10px";

            const bulletNumber = document.createElement("span");
            bulletNumber.textContent = "1";
            bulletNumber.style.color = "#FFF";
            bulletNumber.style.textAlign = "center";
            bulletNumber.style.fontFamily = "Flama";
            bulletNumber.style.fontSize = "24px";
            bulletNumber.style.fontWeight = "650";
            bulletNumber.style.lineHeight = "100%";

            bullet.appendChild(bulletNumber);
            bulletTextContainer.appendChild(bullet);

            const questionText = document.createElement("h1");
            questionText.className = "zq-question-text";
            questionText.textContent = specialQuestion.Text;
            questionText.style.marginBottom = "0rem";
            questionText.style.marginTop = "0rem";
            questionText.style.fontSize = "3rem"; // Set font size
            bulletTextContainer.appendChild(questionText);

            specialQuestionContainer.appendChild(bulletTextContainer);

            const inputDiv = document.createElement("div");
            inputDiv.className = "zq-field";

            const input = document.createElement("input");
            input.id = `zitamineQuizMedicalQuestion-${specialQuestion.Id}`;
            input.type = "date";

            // Applying the same styles as other inputs
            input.style.width = "100%";
            input.style.height = "7rem";
            input.style.background = "#FFFFFF";
            input.style.border = "1px solid #DEDEDE";
            input.style.boxShadow = "0px 0px 1.4rem rgba(0, 0, 0, 0.02)";
            input.style.borderRadius = "7rem";
            input.style.paddingLeft = "3rem";
            input.style.paddingRight = "3rem";
            input.style.textAlign = "center";
            input.style.marginBottom = "2.5rem";
            input.style.fontSize = "2.9rem";
            input.style.lineHeight = "2.9rem";
            input.style.fontFamily = "var(--font-heading-family)";
            
            errorMessage = document.createElement("span");
            errorMessage.textContent = "Vă rugăm să completați data";
            errorMessage.style.color = "red";
            errorMessage.style.display = "none";
            errorMessage.style.fontSize = "1.6rem";
            errorMessage.style.marginBottom = "2.5rem";
            errorMessage.style.marginLeft = "2rem";

            inputDiv.appendChild(input);
            inputDiv.appendChild(errorMessage);
            specialQuestionContainer.appendChild(inputDiv);

            const adjustMarginForScreenSize = () => {
                const isMobile = window.innerWidth <= 768;
            };

            adjustMarginForScreenSize();
            window.addEventListener("resize", adjustMarginForScreenSize);

            contentContainer.appendChild(specialQuestionContainer);

            const secondContainer = document.createElement("div");
            secondContainer.className = "zq-medical-question";
            secondContainer.style.display = "flex";
            secondContainer.style.flexDirection = "column";
            secondContainer.style.alignItems = "flex-start";

            const bulletLabelContainer = document.createElement("div");
            bulletLabelContainer.style.display = "flex";
            bulletLabelContainer.style.alignItems = "center";

            const bulletTwo = document.createElement("div");
            bulletTwo.style.display = "flex";
            bulletTwo.style.width = "40px";
            bulletTwo.style.height = "40px";
            bulletTwo.style.padding = "10.5px 19.5px";
            bulletTwo.style.justifyContent = "center";
            bulletTwo.style.alignItems = "center";
            bulletTwo.style.borderRadius = "100px";
            bulletTwo.style.background = "var(--Indigo, #043B6C)";
            bulletTwo.style.marginRight = "10px";

            const bulletNumberTwo = document.createElement("span");
            bulletNumberTwo.textContent = "2";
            bulletNumberTwo.style.color = "#FFF";
            bulletNumberTwo.style.textAlign = "center";
            bulletNumberTwo.style.fontFamily = "Flama";
            bulletNumberTwo.style.fontSize = "24px";
            bulletNumberTwo.style.fontWeight = "650";
            bulletNumberTwo.style.lineHeight = "100%";

            bulletTwo.appendChild(bulletNumberTwo);
            bulletLabelContainer.appendChild(bulletTwo);

            const label = document.createElement("h1");
            label.className = "zq-question-text";
            label.textContent = "Rezultatele analizelor";
            label.style.marginBottom = "0px";
            label.style.marginTop = "0rem";
            label.style.fontSize = "3rem"; // Set font size
            bulletLabelContainer.appendChild(label);

            secondContainer.appendChild(bulletLabelContainer);

            const adjustMarginForSecondContainer = () => {
                const isMobile = window.innerWidth <= 768;
                bulletLabelContainer.style.marginBottom = isMobile ? "0px" : "-5rem";
            };

            adjustMarginForSecondContainer();
            window.addEventListener("resize", adjustMarginForSecondContainer);
            secondContainer.appendChild(bulletLabelContainer);
            contentContainer.appendChild(secondContainer);
        }

        // Initial font size adjustment
        adjustTitleForScreenSize();

        // Adjust font size on window resize
        window.addEventListener("resize", adjustTitleForScreenSize);

        // Determine if mobile layout is needed
        const isMobile = window.innerWidth <= 768;
        const numberOfColumns = isMobile ? 1 : 2;
        // Rows and Columns
        const row = document.createElement("div");
        row.className = "row";
        row.style.marginBottom = "2rem";

        contentContainer.appendChild(row);

        const adjustLayoutForScreenSize = () => {
            const isMobile = window.innerWidth <= 768;
            row.style.display = isMobile ? "block" : "flex";
            row.style.justifyContent = isMobile ? "" : "center";
        };

        // Initial layout adjustment
        adjustLayoutForScreenSize();
        window.addEventListener("resize", adjustLayoutForScreenSize);

        let specialQuestionContainer = null;

        const columns = Array.from({ length: numberOfColumns }, () => {
            const column = document.createElement("div");
            column.className = "column";
            column.style.marginRight = "2rem";

            row.appendChild(column);

            return column;
        });
        
        const uploadRow = document.createElement("div");
        const loadingSpinner = document.createElement("div");
        loadingSpinner.className = "loading-spinner-upload";
        loadingSpinner.style.display = "none";
        
        try {
            uploadRow.id = "fileUploadSection";
            uploadRow.className = "uploadRow";
            uploadRow.style.marginBottom = "10rem";
            contentContainer.appendChild(uploadRow);

            const anotherOptionSpan = $("<p>").attr({
                class: "upload-file-another-option",
                id: "anotherOption",
            });

            anotherOptionSpan.text("SAU");

            const fileInput = $("<input>").attr({
                type: "file",
                id: "fileInput",
                accept: ".jpg, .jpeg, .png, .pdf",
                class: "file-upload-input",
            });

            const fileLabel = $("<label>").attr({
                class: "drop-container",
                id: "dropcontainer",
                for: "fileInput",
            });

            const fileSpan = $("<span>").attr({
                class: "drop-title",
                id: "dropTitle",
            });

            const svgElement = $("<div>").attr({
                class: "uploadSVG", // Replace with your desired ID
            });

            svgElement.html('<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14V34C8 38.418 15.163 42 24 42C25.381 42 26.721 41.913 28 41.748M8 14C8 18.418 15.163 22 24 22C32.837 22 40 18.418 40 14M8 14C8 9.582 15.163 6 24 6C32.837 6 40 9.582 40 14M40 14V28M40 24C40 28.418 32.837 32 24 32C15.163 32 8 28.418 8 24M40 34V40M40 40V46M40 40H46M40 40H34" stroke="#043B6C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /> </svg>')

            // Create a title element
            const titleElement = $("<div>").attr({
                class: "upload-file-title",
            });

            titleElement.text("Dă click aici pentru a urca un fișier PDF cu rezultatele analizelor tale");

            // Create a subtitle element
            const subtitleElement = $("<div>").attr({
                class: "upload-file-subtitle",
            });

            subtitleElement.text("Atenție! Fișierul trebuie să fie în format PDF. Mărimea sa nu trebuie să depășească 1MB.");

            const fileUploaded = $("<span>").attr({
                class: "upload-file-subtitle",
                id: "fileUploaded",
            });

            fileSpan.append(svgElement, titleElement, subtitleElement, fileUploaded);

            fileLabel.append(fileSpan);
            fileLabel.append(fileInput);

            fileLabel.on("dragover", (e) => {
                // prevent default to allow drop
                e.preventDefault()
            }, false)

            fileLabel.on("dragenter", () => {
                fileLabel.addClass("drag-active")
            })

            fileLabel.on("dragleave", () => {
                fileLabel.removeClass("drag-active")
            })

            let uploadingStatus = false;

            fileLabel.on("drop", (e) => {
                e.preventDefault()
                const droppedFiles = e.originalEvent.dataTransfer.files;

                if (uploadingStatus === true) {
                    return;
                }

                // Set the files property of fileInput
                fileInput.prop("files", droppedFiles);
                fileInput.change();
            })

            const fileLimitMessageContainer = document.createElement("div");
            fileLimitMessageContainer.id = "fileLimit";
            fileLimitMessageContainer.style.margin = "1rem auto 0 auto";
            fileLimitMessageContainer.style.textAlign = "center";

            const uploadContinueButton = $("<input>").attr({
                type: "button",
                id: "uploadContinueButton",
                value: "Salvează",
                class: "upload-continue-button",
            });
            let mySelf = this;

            fileInput.on("change", function () {
                if (uploadingStatus === true) {
                    return;
                }

                var fileInput = this;
                var file = fileInput.files[0];
                var fileSize = file.size;
                var fileLimitElement = jQuery("#fileLimit");
                var uploadContinueElement = jQuery("#uploadContinueButton");

                // Check file size
                if (fileSize > 1000000) {
                    fileLimitElement.html(
                        'Fișierul este prea mare.<br>' +
                        'Dimensiunea maximă permisă este de 1&nbsp;MB.<br>' +
                        'Te rugăm să ne trimiți fișierul pe email la ' +
                        '<a href="mailto:hello@zitamine.ro">hello@zitamine.ro</a> ' +
                        'pentru a finaliza chestionarul. Mulțumim!'
                    );
                    fileLimitElement.css('color', '#dd4b39');
                    fileLimitElement.val('');
                    uploadContinueElement.attr('disabled', 'disabled');
                    jQuery(this).val(null);
                    return false;
                }

                // Check file extension
                var validExtensions = ["jpg", "jpeg", "png", "pdf"];
                var fileExtension = file.name.split(".").pop().toLowerCase();
                if (validExtensions.indexOf(fileExtension) === -1) {
                    fileLimitElement.html("Fisier invalid.");
                    fileLimitElement.css("color", "#dd4b39");
                    fileLimitElement.val("");
                    uploadContinueElement.attr("disabled", "disabled");
                    jQuery(this).val(null);
                    return false;
                }
                mySelf.#uploadedFile = true;
                // File size and type are valid
                fileLimitElement.html("Fișier valid.");
                fileLimitElement.css("color", "green");
                uploadContinueElement.prop("disabled", false);

                // Show file name
                fileUploaded.html(file.name);
            });

            uploadContinueButton.on("click", () => {
                if(!this.#uploadedFile) {
                    const datePickerInput = document.getElementById(
                        `zitamineQuizMedicalQuestion-${specialQuestion.Id}`
                    );
                    this.handleNextMedicalButtonClick();
                    return;
                }
                
                if (this.#uploadStatus === true) {
                    return;
                }

                this.#uploadStatus = true;
                uploadingStatus = true;
                uploadContinueButton.prop("disabled", true);
                loadingSpinner.style.display = "block";
                fileInput.prop("disabled", true);

                var fileLimitElement = $("#fileLimit");
                var fileInputElement = $("#fileInput")[0];
                var file = fileInputElement.files[0];

                var data = new FormData();
                data.append("file", file);

                var test = this.getCurrentQuestionModel();
                const testKey = test.TestKey;
                var url = this.#QUIZ_ENDPOINT_PREFIX.concat("/file/upload/", testKey);

                fetch(this.#MALWARE_SCAN_ENDPOINT, {
                    body: data,
                    method: "POST",
                    processData: false,
                    contentType: false,
                })
                    .then((response) => {
                        if (response.status) {
                            return response.json();
                        }
                        return response;
                    })
                    .then((response) => {
                        if (response === true) {
                            fileLimitElement.html("Fisierul nu a putut fi incarcat.");
                            fileLimitElement.css("color", "#dd4b39");

                            this.#uploadStatus = false;
                            uploadingStatus = false;
                            uploadContinueButton.prop("disabled", false);
                            loadingSpinner.style.display = "none";
                            fileInput.prop("disabled", false);
                            return;
                        }

                        fetch(url, {
                            body: data,
                            method: "POST",
                            processData: false,
                            contentType: false,
                        })
                            .catch((response) => {
                                console.error(response);
                                fileLimitElement.html("Fisierul nu a putut fi incarcat.");
                                fileLimitElement.css("color", "#dd4b39");
                                this.#uploadStatus = false;
                                uploadingStatus = false;

                                uploadContinueButton.prop("disabled", false);
                                loadingSpinner.style.display = "none";
                                fileInput.prop("disabled", false);
                            })
                            .then((response) => {
                                this.#fileUploadedSuccessfully = true;

                                fileLimitElement.html("Fisier incarcat.");
                                fileLimitElement.css("color", "green");

                                this.#uploadStatus = false;
                                uploadingStatus = false;
                                uploadContinueButton.prop("disabled", false);
                                loadingSpinner.style.display = "none";
                                fileInput.prop("disabled", false); 
                                this.handleNextMedicalButtonClick();
                            });
                    })
                    .catch((response) => {
                        fileLimitElement.html("Fisierul nu a putut fi incarcat.");
                        fileLimitElement.css("color", "#dd4b39");

                        this.#uploadStatus = false;
                        uploadingStatus = false;
                        uploadContinueButton.prop("disabled", false);
                        loadingSpinner.style.display = "none";
                        fileInput.prop("disabled", false);
                    });
            });

            const uploadNote = $("<p>").attr({
                class: "upload-note",
            });

            uploadNote.text("Pentru recomandările personalizate luăm în considerare doar cei mai importanți biomarkeri pe care îi găsești în lista de mai sus. Pentru alte analize, te rugăm să consulți un medic specialist.");

            $(uploadRow).append(anotherOptionSpan);
            $(uploadRow).append(fileLabel);
            $(uploadRow).append(fileLimitMessageContainer);
            $(uploadRow).append(loadingSpinner);
            $(uploadRow).append(uploadNote);
            $(uploadRow).append(uploadContinueButton);

        } catch (error) {
            console.error("Error creating file upload section:", error);
        }

        const remainingQuestions = data.filter((question) => question.Id !== 98);

        const style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = `
          .input-placeholder::placeholder {
              font-size: 3rem; /* Adjust the font size as needed */
              color: #666; /* You can also change the color if needed */
          }`;
        document.head.appendChild(style);
        
        // Questions
        remainingQuestions.forEach((question, index) => {
            const column = columns[index % numberOfColumns];
            const questionContainer = document.createElement("div");
            questionContainer.className = "zq-medical-question";

            const questionText = document.createElement("h1");
            questionText.className = "zq-question-text";
            questionText.style.marginBottom = "0px";

            const label = document.createElement("label");
            label.setAttribute("for", `zitamineQuizMedicalQuestion-${question.Id}`);
            label.textContent = question.Text;
            label.style.fontSize = "2.5rem";
            label.style.lineHeight = "0";

            questionText.appendChild(label);
            questionContainer.appendChild(questionText);

            const inputDiv = document.createElement("div");
            inputDiv.className = "zq-field";
            inputDiv.style.position = "relative";

            const input = document.createElement("input");
            input.id = `zitamineQuizMedicalQuestion-${question.Id}`;
            input.type = "text";
            input.className = "input-placeholder";
            input.style.width = "100%";
            input.style.height = "7rem";
            input.addEventListener("input", () => {
                // Replace periods with commas
                input.value = input.value.replace(/\./g, ",");

                // Allow only digits and a single comma
                input.value = input.value
                    .replace(/[^0-9,]/g, "")
                    .replace(/(,.*),/g, "$1");
            });
            input.setAttribute("data-zitamine-quiz-answer", "");
            input.setAttribute("placeholder", "Rezultat");

            input.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    const nextIndex = index + 1;
                    if (nextIndex < remainingQuestions.length) {
                        const nextInputId = `zitamineQuizMedicalQuestion-${remainingQuestions[nextIndex].Id}`;
                        const nextInput = document.getElementById(nextInputId);
                        nextInput?.focus();
                    }
                }
            });

            const clearButton = document.createElement("span");
            clearButton.textContent = question.Placeholder || "";
            clearButton.className = "clear-text";
            clearButton.style.display = "flex";
            clearButton.style.padding = "6px 12px";
            clearButton.style.alignItems = "center";
            clearButton.style.gap = "12px";
            clearButton.style.alignSelf = "stretch";
            clearButton.style.borderRadius = "0px 4px 4px 0px";
            clearButton.style.position = "absolute";
            clearButton.style.right = "20px";
            clearButton.style.top = "50%";
            clearButton.style.transform = "translateY(-50%)";
            clearButton.style.fontSize = "20px";
            clearButton.style.cursor = "pointer";
            clearButton.style.color = "#000";

            const adjustButtonForScreenSize = () => {
                const isMobile = window.innerWidth <= 768;
                clearButton.style.top = isMobile ? "40%" : "50%";
            };

            adjustButtonForScreenSize();
            window.addEventListener("resize", adjustButtonForScreenSize);

            clearButton.addEventListener("click", () => {
                input.value = "";
            });

            inputDiv.appendChild(input);
            inputDiv.appendChild(clearButton);
            questionContainer.appendChild(questionText);
            questionContainer.appendChild(inputDiv);
            column.appendChild(questionContainer);

            const adjustLayoutForScreenSize = () => {
                const isMobile = window.innerWidth <= 768;
                inputDiv.style.width = isMobile ? "33.6rem" : "33.6rem";
            };

            adjustLayoutForScreenSize();
            window.addEventListener("resize", adjustLayoutForScreenSize);
        });

        // Footer
        const footerDiv = document.createElement("div");
        footerDiv.className = "zq-footer";

        const nextButtonLink = document.createElement("a");
        nextButtonLink.href = "#";
        nextButtonLink.className = "zq-next-link";
        nextButtonLink.textContent = "Următoarea întrebare";
        nextButtonLink.style.marginRight = "max(0px, calc(((100vw - 1300px)/2) + 0px))";

        nextButtonLink.addEventListener("click", (event) => {
            event.preventDefault();

            if(this.#uploadedFile) {
                console.log("uploading file...");
                this.#uploadStatus = true;
                loadingSpinner.style.display = "block";

                var fileLimitElement = $("#fileLimit");
                var fileInputElement = $("#fileInput")[0];
                var file = fileInputElement.files[0];

                var data = new FormData();
                data.append("file", file);

                var test = this.getCurrentQuestionModel();
                const testKey = test.TestKey;
                var url = this.#QUIZ_ENDPOINT_PREFIX.concat("/file/upload/", testKey);

                fetch(this.#MALWARE_SCAN_ENDPOINT, {
                    body: data,
                    method: "POST",
                    processData: false,
                    contentType: false,
                })
                    .then((response) => {
                        if (response.status) {
                            return response.json();
                        }
                        return response;
                    })
                    .then((response) => {
                        if (response === true) {
                            fileLimitElement.html("Fisierul nu a putut fi incarcat.");
                            fileLimitElement.css("color", "#dd4b39");

                            this.#uploadStatus = false;
                            loadingSpinner.style.display = "none";
                            return;
                        }

                        fetch(url, {
                            body: data,
                            method: "POST",
                            processData: false,
                            contentType: false,
                        })
                            .catch((response) => {
                                console.error(response);
                                fileLimitElement.html("Fisierul nu a putut fi incarcat.");
                                fileLimitElement.css("color", "#dd4b39");
                                this.#uploadStatus = false;
                                loadingSpinner.style.display = "none";
                            })
                            .then((response) => {
                                this.#fileUploadedSuccessfully = true;

                                fileLimitElement.html("Fisier incarcat.");
                                fileLimitElement.css("color", "green");

                                this.#uploadStatus = false;
                                loadingSpinner.style.display = "none"; 
                                this.handleNextMedicalButtonClick();
                            });
                    })
                    .catch((response) => {
                        fileLimitElement.html("Fisierul nu a putut fi incarcat.");
                        fileLimitElement.css("color", "#dd4b39");

                        this.#uploadStatus = false;
                    });
            } else {
                const datePickerInput = document.getElementById(
                    `zitamineQuizMedicalQuestion-${specialQuestion.Id}`
                );
                this.handleNextMedicalButtonClick();
            }
        });

        footerDiv.appendChild(nextButtonLink);
        footerDiv.style.display = "block";

        contentContainer.appendChild(footerDiv);

        el.appendChild(contentContainer);
    }

    handleNextMedicalButtonClick() {
        const allInputs = document.querySelectorAll(".zq-medical-question input");
        var test = this.getCurrentQuestionModel();
        const testKey = test.TestKey;
        
        const questionsData = Array.from(allInputs).map((input) => {
            return {
                Answer: input.value || null,
                AnswerIds: [],
                AnsweredQuestionId: parseInt(
                    input.id.replace("zitamineQuizMedicalQuestion-", "")
                ),
                CustomTextResponse: input.value || null,
                TestKey: testKey,
            };
        });

        this.#api.nextQuestion(questionsData).then((question) => {
            this.processQuestion(question);
        });
    }

    fillQuestionValues(el, data) {
        this.fillDataValues("zitamine-quiz-question", el, data);
    }

    fillAnswerValues(el, data) {
        this.fillDataValues("zitamine-quiz-answer", el, data);
    }

    fillDataValues(prefix, el, data) {
        for (const prop in data) {
            if (typeof data[prop] === "object" && data[prop] !== null) {
                // Not Implemented
            } else {
                this.processDataAttribute(
                    `data-${prefix}-${this.handle(prop)}-inner-html`,
                    (el) => {
                        el.innerHTML = data[prop];
                    }
                );
                this.processDataAttribute(
                    `data-${prefix}-${this.handle(prop)}-inner-html-persist`,
                    (el) => {
                        el.innerHTML = data[prop];
                    },
                    { removeAfter: false }
                );

                this.processDataAttribute(
                    `data-${prefix}-${this.handle(prop)}-placeholder-attribute`,
                    (el) => {
                        el.setAttribute("placeholder", data[prop]);
                    }
                );

                this.processDataAttribute(
                    `data-${prefix}-${this.handle(prop)}-value-attribute`,
                    (el) => {
                        el.setAttribute("value", data[prop]);
                    }
                );

                this.processDataAttribute(
                    `data-${prefix}-${this.handle(prop)}-value`,
                    (el) => {
                        //el.dataset
                    },
                    { setValue: data[prop] }
                );
            }
        }
    }

    processDataAttribute(dataAttribute, callback, optionParams) {
        const options = {
            removeAfter: true,
            setValue: undefined,
            ...optionParams,
        };
        this.#quizWrapperElement
            .querySelectorAll(`[${dataAttribute}]`)
            .forEach((el) => {
                callback(el);
                if (options.removeAfter || options.setValue !== undefined) {
                    const datasetProperty =
                        this.dataAttributeNameToDatasetPropertyName(dataAttribute);
                    if (options.removeAfter) {
                        if (!dataAttribute.endsWith("-persist"))
                            delete el.dataset[datasetProperty];
                    }
                    if (options.setValue !== undefined)
                        el.dataset[datasetProperty] = options.setValue;
                }
            });
    }

    renderQuestion(question) {
        this.fetchQuestionTemplate(question.Type).then(
            ((htmlText) => {
                this.#quizWrapperElement
                    .querySelectorAll("[data-zitamine-quiz-section-template]")
                    .forEach((el) => {
                        el.innerHTML = htmlText;

                        this.fillTemplateValues("zitamine-quiz-question", question);
                        
                        if (question.Id === 2) {
                            const inputElement = document.getElementById('ZitamineQuizInput');
                            if (inputElement) {
                                inputElement.type = 'number';
                                Object.assign(inputElement.style, {
                                    width: "100%",
                                    height: "7rem",
                                    background: "#FFFFFF",
                                    border: "1px solid #DEDEDE",
                                    boxShadow: "0px 0px 1.4rem rgba(0, 0, 0, 0.02)",
                                    borderRadius: "7rem",
                                    paddingLeft: "3rem",
                                    paddingRight: "3rem",
                                    textAlign: "center",
                                    marginBottom: "2.5rem",
                                    fontSize: "50px !important",
                                    lineHeight: "2.9rem",
                                    fontFamily: "var(--font-heading-family)"
                                });

                                const mediaQuery = window.matchMedia('(min-width: 768px)');
                                function handleWidthChange(e) {
                                    if (e.matches) {
                                        inputElement.style.width = "50%";
                                    } else {
                                        inputElement.style.width = "100%";
                                    }
                                }
                                mediaQuery.addListener(handleWidthChange);
                                handleWidthChange(mediaQuery);

                                inputElement.removeAttribute('placeholder');
                                inputElement.id = `datanasterii-${question.Id}`;
                            }
                            
                            if (el.querySelector("[data-zitamine-quiz-hide-prev-button]")) {
                                this.#quizWrapperElement
                                    .querySelectorAll("[data-zitamine-quiz-prev-button]")
                                    .forEach((el) => {
                                        if (!el.closest("[data-zitamine-quiz-section-template]")) {
                                            el.style.display = "none";
                                        }
                                    });
                            } else {
                                this.#quizWrapperElement
                                    .querySelectorAll("[data-zitamine-quiz-prev-button]")
                                    .forEach((el) => {
                                        if (!el.closest("[data-zitamine-quiz-section-template]")) {
                                            el.style.display = null;
                                        }
                                    });

                                this.#quizWrapperElement
                                    .querySelectorAll("[data-zitamine-quiz-next-button]")
                                    .forEach((el) => {
                                        el.style.display = null;
                                    });
                            }
                            return;
                        }

                        if (el.querySelector("[data-zitamine-quiz-hide-prev-button]")) {
                            this.#quizWrapperElement
                                .querySelectorAll("[data-zitamine-quiz-prev-button]")
                                .forEach((el) => {
                                    if (!el.closest("[data-zitamine-quiz-section-template]")) {
                                        el.style.display = "none";
                                    }
                                });
                        } else {
                            this.#quizWrapperElement
                                .querySelectorAll("[data-zitamine-quiz-prev-button]")
                                .forEach((el) => {
                                    if (!el.closest("[data-zitamine-quiz-section-template]")) {
                                        el.style.display = null;
                                    }
                                });
                        }
                        if (el.querySelector("[data-zitamine-quiz-hide-next-button]")) {
                            this.#quizWrapperElement
                                .querySelectorAll("[data-zitamine-quiz-next-button]")
                                .forEach((el) => {
                                    if (!el.closest("[data-zitamine-quiz-section-template]")) {
                                        el.style.display = "none";
                                    }
                                });
                        } else {
                            this.#quizWrapperElement
                                .querySelectorAll("[data-zitamine-quiz-next-button]")
                                .forEach((el) => {
                                    if (!el.closest("[data-zitamine-quiz-section-template]")) {
                                        el.style.display = null;
                                    }
                                });
                            
                            if (typeof jQuery !== 'undefined') {
                                setTimeout(function () {
                                    jQuery(".zq-field input[type=text]").focus();
                                    jQuery("#shopify-section-zitamine-quiz-question-3 input").on(
                                        "keyup",
                                        function (e) {
                                            var length = e.currentTarget.value.length;
                                            if (length > 6) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "2rem"
                                                );
                                            }
                                            if (length > 7) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.9rem"
                                                );
                                            }
                                            if (length > 8) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.8rem"
                                                );
                                            }
                                            if (length > 9) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.7rem"
                                                );
                                            }
                                            if (length > 10) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.6rem"
                                                );
                                            }
                                            if (length > 11) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.5rem"
                                                );
                                            }
                                            if (length > 12) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.4rem"
                                                );
                                            }
                                            if (length > 13) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.3rem"
                                                );
                                            }
                                            if (length > 14) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.2rem"
                                                );
                                            }
                                            if (length > 15) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1.1rem"
                                                );
                                            }
                                            if (length > 16) {
                                                jQuery(".zq-cart-monthly--recommendation-title").css(
                                                    "font-size",
                                                    "1rem"
                                                );
                                            }
                                            jQuery(".zq-cart-monthly--recommendation-title span").html(
                                                e.currentTarget.value
                                            );
                                        }
                                    );
                                    
                                    if (question.Id == 1) {
                                        sessionStorage.setItem(
                                            "ZitamineQuizPrevShouldGoToEmail",
                                            "Should go to email"
                                        );
                                        sessionStorage.removeItem("AlreadyOnEmailQ");
                                        jQuery(".zq-cart-objectives.page-width").show();
                                    } else {
                                        sessionStorage.removeItem("ZitamineQuizPrevShouldGoToEmail");
                                        jQuery(".zq-cart-objectives.page-width").hide();
                                    }
                                    
                                    if (question.MaxAnswers) {
                                        document.body
                                            .querySelectorAll("[data-zitamine-quiz-next-button]")
                                            .forEach((el) => {
                                                if (
                                                    !el.closest("[data-zitamine-quiz-section-template]")
                                                ) {
                                                    el.setAttribute("max_answers", question.MaxAnswers);
                                                }
                                            });
                                    } else {
                                        document.body
                                            .querySelectorAll("[data-zitamine-quiz-next-button]")
                                            .forEach((el) => {
                                                if (
                                                    !el.closest("[data-zitamine-quiz-section-template]")
                                                ) {
                                                    el.removeAttribute("max_answers");
                                                }
                                            });
                                    }
                                    if (question.MinAnswers) {
                                        document.body
                                            .querySelectorAll("[data-zitamine-quiz-next-button]")
                                            .forEach((el) => {
                                                if (
                                                    !el.closest("[data-zitamine-quiz-section-template]")
                                                ) {
                                                    el.setAttribute("min_answers", question.MinAnswers);
                                                }
                                            });
                                    } else {
                                        document.body
                                            .querySelectorAll("[data-zitamine-quiz-next-button]")
                                            .forEach((el) => {
                                                if (
                                                    !el.closest("[data-zitamine-quiz-section-template]")
                                                ) {
                                                    el.removeAttribute("min_answers");
                                                }
                                            });
                                    }
                                }, 500);
                            }
                        }

                        el.dataset.zitamineQuizNextQuestionModel = JSON.stringify(
                            question.NextQuestionModel
                        );

                        if (question.Answers.length > 0) {
                            const answerTemplateElement = el
                                .querySelector("[data-zitamine-quiz-answer-template]")
                                .cloneNode(true);
                            const answersParent = el.querySelector(
                                "[data-zitamine-quiz-answer-template]"
                            ).parentElement;
                            answersParent.innerHTML = "";

                            for (const answer of question.Answers) {
                                const answerTemplateClone =
                                    answerTemplateElement.cloneNode(true);
                                answersParent.appendChild(answerTemplateClone);

                                this.fillAnswerValues(answerTemplateClone, answer);
                                const answerElement = answerTemplateClone.querySelector(
                                    "[data-zitamine-quiz-answer]"
                                );
                                const labelElement = answerTemplateClone.querySelector(
                                    `label[for=${answerElement.id}]`
                                );
                                const answerElementId = `${answerElement.id}_${answer.Id}`;

                                if (answerElement) {
                                    answerElement.id = answerElementId;
                                    if (labelElement) {
                                        labelElement.setAttribute("for", answerElementId);
                                    }
                                }

                                answerTemplateClone.style.order = answer.Sequence;
                                if (answer.Profile) {
                                    answerTemplateClone
                                        .querySelector("input")
                                        .setAttribute("profile", answer.Profile);
                                }
                                if (answer.LastFinishedQuizKey) {
                                    answerTemplateClone
                                        .querySelector("input")
                                        .setAttribute(
                                            "LastFinishedQuizKey",
                                            answer.LastFinishedQuizKey
                                        );
                                }
                            }
                        } else {
                            const labelElement = el.querySelector(
                                "label[data-zitamine-quiz-question-text]"
                            );
                            const answerElement = el.querySelector(
                                "[data-zitamine-quiz-answer]"
                            );
                            const answerElementId = this.generateId();

                            if (answerElement) {
                                answerElement.id = answerElementId.concat();
                                if (labelElement) {
                                    labelElement.setAttribute("for", answerElementId);
                                }
                            }

                            if (
                                question.NextQuestionModel &&
                                question.NextQuestionModel.AnsweredQuestionId === 4
                            ) {
                                answerElement.setAttribute("pattern", "[0-9]{1,3}([.,][0-9])?");
                                answerElement.setAttribute("required", "");

                                answerElement.addEventListener("blur", function (e) {
                                    const value = e.target.value;
                                    const isValid = /^[0-9]{1,3}([.,][0-9])?$/.test(value);

                                    if (!isValid) {
                                        answerElement.setCustomValidity(
                                            "Please enter a valid number."
                                        );
                                    } else {
                                        answerElement.setCustomValidity("");
                                    }
                                });

                                const formElement = document.getElementById("ZitamineQuiz");
                                if (formElement) {
                                    formElement.addEventListener("submit", function (event) {
                                        if (!answerElement.checkValidity()) {
                                            event.preventDefault();
                                            answerElement.reportValidity();
                                        }
                                    });
                                }
                            }

                            if (
                                question.NextQuestionModel &&
                                question.NextQuestionModel.AnsweredQuestionId === 76
                            ) {
                                answerElement.setAttribute("pattern", "^(0|+?4?0)([0-9]{9})$");

                                answerElement.addEventListener("blur", function (e) {
                                    const value = e.target.value;
                                    const isValid = /^(0|\+?4?0)([0-9]{9})$/.test(value);

                                    if (!isValid && value.trim() !== "") {
                                        answerElement.setCustomValidity(
                                            "Please enter a valid Romanian phone number."
                                        );
                                    } else {
                                        answerElement.setCustomValidity("");
                                    }
                                });

                                const formElement = document.getElementById("ZitamineQuiz");
                                if (formElement) {
                                    formElement.addEventListener("submit", function (event) {
                                        if (!answerElement.checkValidity()) {
                                            event.preventDefault();
                                            answerElement.reportValidity();
                                        }
                                    });
                                }
                            }

                            if (
                                question.NextQuestionModel &&
                                question.NextQuestionModel.AnsweredQuestionId === 5
                            ) {
                                answerElement.setAttribute("pattern", "[0-9]{1,3}");
                                answerElement.setAttribute("required", "");

                                answerElement.addEventListener("blur", function (e) {
                                    const value = e.target.value;
                                    const isValid = /^[0-9]{1,3}$/.test(value);

                                    if (!isValid) {
                                        answerElement.setCustomValidity(
                                            "Please enter a valid number with a maximum of 3 digits."
                                        );
                                    } else {
                                        answerElement.setCustomValidity("");
                                    }
                                });

                                const formElement = document.getElementById("ZitamineQuiz");
                                if (formElement) {
                                    formElement.addEventListener("submit", function (event) {
                                        if (!answerElement.checkValidity()) {
                                            event.preventDefault();
                                            answerElement.reportValidity();
                                        }
                                    });
                                }
                            }
                        }
                    });
            }).bind(this)
        );
    }

    // RESTORED: Session storage methods
    saveToSessionStorage() {
        const data = {
            quizResults: this.#quizResults,
            emailAddress: this.#emailAddress,
            firstName: this.#firstName,
            profile: this.#profile,
            utm: this.#utm,
        };
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem("ZitamineQuiz", JSON.stringify(data));
        }
    }

    loadFromSessionStorage() {
        if (typeof sessionStorage !== 'undefined') {
            const dataJSONString = sessionStorage.getItem("ZitamineQuiz");
            if (dataJSONString) {
                const data = JSON.parse(dataJSONString);
                if (
                    this.#emailAddress === undefined ||
                    this.#emailAddress === null ||
                    this.#emailAddress === data.emailAddress
                ) {
                    this.#quizResults = data.quizResults;
                    this.#emailAddress = data.emailAddress;
                    this.#firstName = data.firstName;
                }
                this.#utm = data.utm;
                this.#profile = data.profile;
            }
        }
    }

    startButtonClicked(el) {
        const sectionTemplate = this.#quizWrapperElement.querySelector(
            "[data-zitamine-quiz-section-template]"
        );
        const emailAddress = sectionTemplate.querySelector(
            "[data-zitamine-quiz-email-address]"
        )?.value;
        const emailField = sectionTemplate.querySelector(
            "[data-zitamine-quiz-email-address]"
        );
        var isFieldValid = emailField.checkValidity();
        if (isFieldValid == false) {
            const nameError = document.getElementById("nameError");
            if (nameError) {
                nameError.classList.add("visible");
                nameError.setAttribute("aria-hidden", false);
                nameError.setAttribute("aria-invalid", true);
            }
            emailField.classList.add("invalid");
            return;
        } else {
            const nameError = document.getElementById("nameError");
            if (nameError) {
                nameError.style.display = "none";
            }
        }
        const agreementCheckbox = document.querySelector("#ZitamineQuizAgreement");
        const agreementError = document.querySelector(
            "#ZitamineQuizAgreementError"
        );
        if (agreementCheckbox && agreementCheckbox.checked) {
            if (agreementError) {
                agreementError.style.display = "none";
            }
        } else {
            if (agreementError) {
                agreementError.style.display = "block";
            }
            return;
        }

        const firstName = sectionTemplate.querySelector(
            "[data-zitamine-quiz-first-name]"
        )?.value;
        this.checkUserStatus(emailAddress, firstName);
    }

    checkUserStatus(emailAddress, firstName) {
        this.#api.checkUserStatus(emailAddress).then((status) => {
            this.#storage.emailAddress = emailAddress;
            this.#storage.firstName = firstName;
            if (status.Profiles) {
                this.renderStartOptions(status);
            } else {
                this.startOver();
            }
        });
    }

    // ENHANCED: Start recommendations with package selection
 
// ENHANCED: Start recommendations with suspense loading
startRecommendations(results) {
    console.log('=== STARTING RECOMMENDATIONS (quiz completed) ===');
    console.log('Results received:', results);
    
    if (results !== undefined) {
        this.#storage.quizResults = results;
    } else {
        results = this.#storage.quizResults;
    }
    
    // Check if we have the new 3-package structure
    if (results.Esential && results.Optim && results.Complet) {
        console.log('✅ New package structure detected - showing suspense loading');
        
        // STEP 1: Show suspense loading immediately (ONLY for quiz completion)
        this.showSuspenseLoading();
        
        // STEP 2: Wait 5 seconds then show package selection
        setTimeout(() => {
            this.hideSuspenseLoading();
            this.showPackageSelectionOnly(results);
        }, 3000);
        
        return;
    }
    
    // Legacy logic for backward compatibility
    console.log('⚠️ Using legacy recommendation structure');
    
    // Show loader temporarily for legacy flow
    if (typeof jQuery !== 'undefined') {
        jQuery(".loader").show();
        jQuery(".zq-header").hide();
        jQuery(".zq-content").hide();
        jQuery(".zq-footer").hide();
    }
    
    if (results.MonthlyRecommendations) {
        if (results.MonthlyRecommendations[0]) {
            const productRecommendations = results.MonthlyRecommendations[0].Recommendations;
            this.addRecommendationsToCart(productRecommendations);
        } else {
            if (typeof jQuery !== 'undefined') {
                jQuery(".loader").hide();
            }
            window.location.pathname = "/cart";
        }
    } else {
        if (typeof jQuery !== 'undefined') {
            jQuery(".loader").hide();
        }
        window.location.pathname = "/cart";
    }
}

showSuspenseLoading() {
    console.log('🎭 Showing suspense loading...');
    
    // Keep existing UI elements visible (don't hide them)
    // Only hide any existing loaders
    if (typeof jQuery !== 'undefined') {
        jQuery(".loader").hide(); // Hide default loader only
    }
    
    // Create suspense loading container if it doesn't exist
    if (!document.getElementById('suspense-loading-container')) {
        const suspenseContainer = document.createElement('div');
        suspenseContainer.id = 'suspense-loading-container';
        suspenseContainer.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: transparent;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 10000;
            font-family: var(--font-body-family, Arial, sans-serif);
            pointer-events: none;
        `;

        // Create content wrapper with background (full screen)
        const contentWrapper = document.createElement('div');
        contentWrapper.style.cssText = `
            background: rgba(255, 255, 255, 0.98);
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(10px);
        `;

        // Create modern animated spinner
        const spinner = document.createElement('div');
        spinner.className = 'suspense-spinner';
        spinner.style.cssText = `
            width: 50px;
            height: 50px;
            border: 3px solid transparent;
            border-top: 3px solid #043B6C;
            border-right: 3px solid #043B6C;
            border-radius: 50%;
            animation: modernSpinAnimation 1.2s linear infinite;
            margin-bottom: 25px;
            position: relative;
        `;

        // Add inner spinner for more dynamic effect
        const innerSpinner = document.createElement('div');
        innerSpinner.style.cssText = `
            position: absolute;
            top: 6px;
            left: 6px;
            width: 32px;
            height: 32px;
            border: 2px solid transparent;
            border-bottom: 2px solid rgba(4, 59, 108, 0.4);
            border-left: 2px solid rgba(4, 59, 108, 0.4);
            border-radius: 50%;
            animation: modernSpinAnimation 1s linear infinite reverse;
        `;
        spinner.appendChild(innerSpinner);

        // Create main loading text
        const loadingText = document.createElement('div');
        loadingText.className = 'suspense-loading-text';
        loadingText.innerHTML = 'Lucrăm la cele mai bune opțiuni pentru tine<br>în funcție de priorități';
        loadingText.style.cssText = `
            font-size: 20px;
            color: #043B6C;
            font-weight: 600;
            text-align: center;
            line-height: 1.4;
            margin-bottom: 12px;
            max-width: 350px;
        `;

        // Create subtitle
        const subText = document.createElement('div');
        subText.className = 'suspense-sub-text';
        subText.textContent = 'Un moment, te rog...';
        subText.style.cssText = `
            font-size: 16px;
            color: #666;
            font-weight: 400;
            text-align: center;
        `;

        // Add CSS animations if not already present
        if (!document.getElementById('suspense-loading-styles')) {
            const style = document.createElement('style');
            style.id = 'suspense-loading-styles';
            style.textContent = `
                @keyframes modernSpinAnimation {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                
                @media (max-width: 768px) {
                    .suspense-loading-text {
                        font-size: 18px !important;
                        max-width: 280px !important;
                    }
                    
                    .suspense-sub-text {
                        font-size: 14px !important;
                    }
                    
                    .suspense-spinner {
                        width: 40px !important;
                        height: 40px !important;
                        margin-bottom: 20px !important;
                    }
                    
                    .suspense-spinner > div {
                        top: 5px !important;
                        left: 5px !important;
                        width: 24px !important;
                        height: 24px !important;
                    }
                }
            `;
            document.head.appendChild(style);
        }

        contentWrapper.appendChild(spinner);
        contentWrapper.appendChild(loadingText);
        contentWrapper.appendChild(subText);
        suspenseContainer.appendChild(contentWrapper);
        document.body.appendChild(suspenseContainer);
    } else {
        // Show existing container
        document.getElementById('suspense-loading-container').style.display = 'flex';
    }
}

// NEW: Hide suspense loading
hideSuspenseLoading() {
    console.log('🎭 Hiding suspense loading...');
    
    const suspenseContainer = document.getElementById('suspense-loading-container');
    if (suspenseContainer) {
        // Smooth fade out effect
        suspenseContainer.style.transition = 'opacity 0.5s ease-out';
        suspenseContainer.style.opacity = '0';
        
        setTimeout(() => {
            suspenseContainer.style.display = 'none';
            suspenseContainer.style.opacity = '1'; // Reset for next time
        }, 500);
    }
    
    // Ensure UI elements are visible for package selection
    if (typeof jQuery !== 'undefined') {
        jQuery(".zq-header").css("display", "grid").show();
        jQuery(".zq-content").show();
        jQuery(".zq-footer").show();
    }
}


    // NEW: Show package selection
showPackageSelection(results) {
    console.log('=== SHOWING PACKAGE SELECTION ===');
    
    jQuery(".loader").hide();
    jQuery(".zq-header").css("display", "grid");
    jQuery(".zq-content").show();
    jQuery(".zq-footer").show();

    const packageQuestion = this.createPackageSelectionQuestion(results);
    this.renderPackageSelection(packageQuestion);
}

    // NEW: Create package selection question
    createPackageSelectionQuestion(results) {
        return {
            Id: 'package-selection',
            Type: 'package-selection',
            Text: 'Alege pachetul potrivit pentru tine',
            InfoText: null,
            ShouldStopQuiz: false,
            IsQuizOver: false,
            TestKey: null,
            Placeholder: null,
            TimeRemaining: null,
            ProgressBar: null,
            Answers: [
                {
                    Id: 'esential',
                    Text: 'Pachet Basic',
                    Sequence: 1,
                    PackageData: results.Esential
                },
                {
                    Id: 'optim',
                    Text: 'Pachet Elevate',
                    Sequence: 2,
                    PackageData: results.Optim
                },
                {
                    Id: 'complet',
                    Text: 'Pachet Supreme',
                    Sequence: 3,
                    PackageData: results.Complet
                }
            ],
            Results: results
        };
    }

    // NEW: Render package selection
    renderPackageSelection(packageQuestion) {
        const el = this.#quizWrapperElement.querySelector("[data-zitamine-quiz-section-template]");
        
        if (el) {
            el.innerHTML = this.generatePackageSelectionHTML(packageQuestion);
            
            this.#quizWrapperElement
                .querySelectorAll("[data-zitamine-quiz-prev-button]")
                .forEach((btn) => {
                    if (!btn.closest("[data-zitamine-quiz-section-template]")) {
                        btn.style.display = "none";
                    }
                });
                
            this.#quizWrapperElement
                .querySelectorAll("[data-zitamine-quiz-next-button]")
                .forEach((btn) => {
                    if (!btn.closest("[data-zitamine-quiz-section-template]")) {
                        btn.style.display = "none";
                    }
                });

            this.attachPackageSelectionHandlers();
        }
    }

    // NEW: Generate package selection HTML
// Modified generatePackageSelectionHTML method to include info tooltips
generatePackageSelectionHTML(packageQuestion) {
    // Filter out duplicate packages first
    const uniquePackages = this.filterUniquePackages(packageQuestion.Answers);
    
    let html = `
        <div class="package-selection-container">
            <h1 class="package-selection-title">${packageQuestion.Text}</h1>
            <div class="packages-container">
    `;
    
    uniquePackages.forEach((pkg, index) => {
        const isRecommended = pkg.Id === 'optim';
        const supplements = pkg.PackageData?.Recommendations || [];
        const totalPrice = this.calculatePackageTotal(pkg.PackageData);
        const pricePerDay = (totalPrice / 30).toFixed(2);
        
        html += `
            <div class="package-card ${isRecommended ? 'recommended' : ''}" data-package-type="${pkg.Id}">
                ${isRecommended ? '<div class="recommended-badge">Recomandat</div>' : ''}
                
                <div class="package-header">
                    <h2 class="package-title">${pkg.Text}</h2>
                    <div class="package-duration">(pentru 30 de zile)</div>
                </div>
                
                <div class="supplements-list">
        `;
        
        // Show supplements with info buttons if SupplementInfoText exists
        supplements.forEach(supplement => {
            const hasInfoText = supplement.SupplementInfoText && supplement.SupplementInfoText.trim() !== '';
            
            html += `
                <div class="supplement-item">
                    <div class="supplement-info">
                        <div class="supplement-name-container">
                            <span class="supplement-name">${supplement.Name}</span>
                            ${hasInfoText ? `
                                <span class="supplement-info-button" data-tooltip="${this.escapeHtml(supplement.SupplementInfoText)}">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="10" stroke="#043B6C" stroke-width="2"/>
                                        <path d="M9,9 a3,3 0 1,1 6,0c0,2 -3,3 -3,3" stroke="#043B6C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <circle cx="12" cy="17" r="1" fill="#043B6C"/>
                                    </svg>
                                    <div class="supplement-tooltip hidden">${supplement.SupplementInfoText}</div>
                                </span>
                            ` : ''}
                        </div>
                        <div class="supplement-quantity">${supplement.Quantity} buc</div>
                    </div>
                </div>
            `;
        });
        
        html += `
                </div>
                
                <div class="package-total-section">
                    <div class="price-box">
                        <div class="price-text">
                            Preț pentru 30 de zile<br>
                            <strong>${totalPrice} Lei</strong>
                        </div>
                        <div class="price-subtext">${pricePerDay} Lei/zi</div>
                    </div>
                    
                    <div class="selection-text">
                        Selectează varianta de abonament pentru o reducere de până la 15% și consultații online gratuite cu medicii noștri.
                    </div>
                    
                    <button class="package-select-button" data-package-id="${pkg.Id}">
                        Pasul Următor
                    </button>
                </div>
            </div>
        `;
    });
    
    html += `
            </div>
        </div>
        
        ${this.getUpdatedPackageSelectionCSS()}
    `;
    
    return html;
}

// Helper method to escape HTML for safe tooltip content
escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML.replace(/"/g, '&quot;');
}

// Updated CSS with tooltip styles
getUpdatedPackageSelectionCSS() {
    return `
        <style>
            /* Hide header and timer bar for package selection */
            .zq-header,
            .zq-timer,
            .timer-bar,
            .progress-bar,
            .zq-progressbar {
                display: none !important;
                visibility: hidden !important;
            }
            
            .package-selection-container {
                padding: 1rem 2rem;
                max-width: 1200px;
                margin: 0 auto;
            }
            
            .package-selection-title {
                font-size: 2.8rem;
                line-height: 1.2;
                font-family: var(--font-heading-family, 'Arial', sans-serif);
                color: #043B6C;
                text-align: center;
                margin-bottom: 2rem;
            }
            
            .packages-container {
                display: grid;
                gap: 1.5rem;
                margin-bottom: 1.5rem;
            }
            
            .package-card {
                background: #FFFFFF;
                border: 1px solid #DEDEDE;
                border-radius: 1.2rem;
                padding: 1.5rem;
                box-shadow: 0px 0px 1.4rem rgba(0, 0, 0, 0.02);
                transition: transform 0.2s ease, box-shadow 0.2s ease;
                position: relative;
                display: flex;
                flex-direction: column;
            }
            
            .package-card:hover {
                transform: translateY(-4px);
                box-shadow: 0px 8px 2rem rgba(0, 0, 0, 0.12);
            }
            
            .package-card.recommended {
                border: 2px solid #043B6C;
                transform: scale(1.02);
            }
            
            .package-card.recommended:hover {
                transform: scale(1.02) translateY(-4px);
            }
            
            .recommended-badge {
                position: absolute;
                top: -10px;
                left: 50%;
                transform: translateX(-50%);
                background: #28a745;
                color: white;
                padding: 0.3rem 1rem;
                border-radius: 0.8rem;
                font-size: 1rem;
                font-weight: 600;
                white-space: nowrap;
            }
            
            .package-header {
                text-align: center;
                margin-bottom: 1.5rem;
            }
            
            .package-title {
                font-size: 1.8rem;
                font-weight: 650;
                color: #043B6C;
                margin: 0 0 0.3rem 0;
                font-family: var(--font-heading-family, 'Arial', sans-serif);
            }
            
            .package-duration {
                font-size: 1.2rem;
                color: #666;
                font-weight: 400;
                margin: 0;
                font-family: var(--font-body-family, 'Arial', sans-serif);
            }
            
            .supplements-list {
                flex-grow: 1;
                margin-bottom: 1.5rem;
                min-height: 160px;
            }
            
            .supplement-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.6rem 0;
                border-bottom: 1px solid #f0f0f0;
            }
            
            .supplement-item:last-child {
                border-bottom: none;
            }
            
            .supplement-info {
                flex-grow: 1;
            }
            
            .supplement-name-container {
                align-items: center;
                gap: 0.3rem;
                margin-bottom: 0.3rem;
            }
            
            .supplement-name {
                font-size: 1.3rem;
                color: #043B6C;
                font-weight: 500;
                line-height: 1.2;
                flex: 1;
            }
            
            .supplement-info-button {
                cursor: pointer;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 14px;
                height: 14px;
                flex-shrink: 0;
                opacity: 0.7;
                transition: opacity 0.2s ease;
                margin-left: 0.2rem;
                position: relative;
            }
            
            .supplement-info-button:hover {
                opacity: 1;
            }
            
            .supplement-info-button svg {
                width: 14px;
                height: 14px;
            }
            
            .supplement-tooltip {
                position: absolute;
                bottom: calc(100% + 0.6rem);
                left: 50%;
                transform: translateX(-50%);
                background: #2c3e50;
                color: white;
                padding: 0.6rem 0.8rem;
                border-radius: 0.4rem;
                font-size: 1.1rem;
                font-weight: 400;
                line-height: 1.3;
                max-width: 200px;
                min-width: 150px;
                white-space: normal;
                word-wrap: break-word;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                z-index: 10000;
                transition: opacity 0.2s ease, visibility 0.2s ease;
                pointer-events: none;
            }
            
            .supplement-tooltip::after {
                content: '';
                position: absolute;
                top: 100%;
                left: 50%;
                transform: translateX(-50%);
                border: 5px solid transparent;
                border-top-color: #2c3e50;
            }
            
            .supplement-tooltip.hidden {
                opacity: 0;
                visibility: hidden;
            }
            
            .supplement-tooltip.visible {
                opacity: 1;
                visibility: visible;
            }
            
            .supplement-quantity {
                font-size: 1.1rem;
                color: #666;
            }
            
            .package-total-section {
                border-top: 2px solid #f0f0f0;
                padding-top: 1.5rem;
                text-align: center;
            }
            
            .price-box {
                background: #f8f9fa;
                padding: 1.2rem;
                border-radius: 0.8rem;
                margin-bottom: 1.2rem;
            }
            
            .price-text {
                font-size: 1.4rem;
                color: #043B6C;
                margin-bottom: 0.3rem;
            }
            
            .price-text strong {
                font-size: 1.8rem;
                font-weight: 650;
            }
            
            .price-subtext {
                font-size: 1.1rem;
                color: #666;
            }
            
            .selection-text {
                font-size: 1.1rem;
                color: #666;
                margin-bottom: 1.5rem;
                line-height: 1.3;
            }
            
            .package-select-button {
                background: #043B6C;
                color: white;
                border: none;
                padding: 1.2rem 2.5rem;
                border-radius: 2.5rem;
                font-size: 1.4rem;
                font-weight: 600;
                cursor: pointer;
                transition: background-color 0.2s ease;
                width: 100%;
                font-family: var(--font-heading-family, 'Arial', sans-serif);
            }
            
            .package-select-button:hover {
                background: #032f5a;
            }
            
            .recommended .package-select-button {
                background: #28a745;
            }
            
            .recommended .package-select-button:hover {
                background: #218838;
            }
            
            @media (max-width: 768px) {
                .package-selection-container {
                    padding: 0.5rem 1rem;
                }
                
                .package-selection-title {
                    font-size: 2rem;
                    margin-bottom: 1.5rem;
                }
                
                .packages-container {
                    grid-template-columns: 1fr;
                    gap: 1rem;
                }
                
                .package-card {
                    padding: 1.2rem;
                }
                
                .package-title {
                    font-size: 1.6rem;
                }
                
                .package-duration {
                    font-size: 1.1rem;
                }
                
                .supplement-name {
                    font-size: 1.2rem;
                }
                
                .price-text {
                    font-size: 1.3rem;
                }
                
                .price-text strong {
                    font-size: 1.6rem;
                }
                
                .package-select-button {
                    font-size: 1.3rem;
                    padding: 1rem 2rem;
                }
                
                .package-card.recommended {
                    transform: none;
                }
                
                .package-card.recommended:hover {
                    transform: translateY(-4px);
                }
                
                .supplement-tooltip {
                    max-width: 180px;
                    font-size: 1rem;
                }
            }
        </style>
    `;
}

// Enhanced attachPackageSelectionHandlers to include tooltip functionality
attachPackageSelectionHandlers() {
    console.log('🔧 Attaching package selection handlers...');
    
    const selectButtons = this.#quizWrapperElement.querySelectorAll('.package-select-button');
    
    selectButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            const packageId = e.target.getAttribute('data-package-id');
            this.handlePackageSelection(packageId);
        });
    });

    // Add tooltip handlers with better debugging
    const infoButtons = this.#quizWrapperElement.querySelectorAll('.supplement-info-button');
    console.log('📋 Found info buttons:', infoButtons.length);
    
    infoButtons.forEach((button, index) => {
        console.log(`🔍 Processing info button ${index + 1}:`, button);
        
        const tooltip = button.querySelector('.supplement-tooltip');
        
        console.log(`💬 Tooltip found:`, !!tooltip);
        
        if (tooltip) {
            console.log(`✅ Setting up tooltip for button ${index + 1} with content:`, tooltip.textContent);
            
            // Remove any existing event listeners to avoid duplicates
            button.removeEventListener('mouseenter', button._tooltipMouseEnter);
            button.removeEventListener('mouseleave', button._tooltipMouseLeave);
            button.removeEventListener('touchstart', button._tooltipTouchStart);
            
            // Create named functions for easier debugging
            button._tooltipMouseEnter = () => {
                console.log('🖱️ Mouse enter - showing tooltip');
                // Hide all other tooltips first
                const allTooltips = this.#quizWrapperElement.querySelectorAll('.supplement-tooltip');
                allTooltips.forEach(t => {
                    if (t !== tooltip) {
                        t.classList.remove('visible');
                        t.classList.add('hidden');
                    }
                });
                
                tooltip.classList.remove('hidden');
                tooltip.classList.add('visible');
                console.log('📍 Tooltip should now be visible');
            };
            
            button._tooltipMouseLeave = () => {
                console.log('🖱️ Mouse leave - hiding tooltip');
                tooltip.classList.remove('visible');
                tooltip.classList.add('hidden');
            };
            
            button._tooltipTouchStart = (e) => {
                e.preventDefault();
                console.log('👆 Touch start - toggling tooltip');
                
                // Hide all other tooltips first
                const allTooltips = this.#quizWrapperElement.querySelectorAll('.supplement-tooltip');
                allTooltips.forEach(t => {
                    if (t !== tooltip) {
                        t.classList.remove('visible');
                        t.classList.add('hidden');
                    }
                });
                
                // Toggle current tooltip
                if (tooltip.classList.contains('visible')) {
                    tooltip.classList.remove('visible');
                    tooltip.classList.add('hidden');
                } else {
                    tooltip.classList.remove('hidden');
                    tooltip.classList.add('visible');
                }
            };
            
            // Attach the event listeners
            button.addEventListener('mouseenter', button._tooltipMouseEnter);
            button.addEventListener('mouseleave', button._tooltipMouseLeave);
            button.addEventListener('touchstart', button._tooltipTouchStart);
            
            console.log(`✅ Event listeners attached for button ${index + 1}`);
        } else {
            console.warn(`❌ No tooltip found for info button ${index + 1}`);
        }
    });
    
    // Hide tooltips when clicking outside (only attach once)
    if (!document._tooltipClickHandler) {
        document._tooltipClickHandler = (e) => {
            if (!e.target.closest('.supplement-info-button')) {
                const allTooltips = this.#quizWrapperElement.querySelectorAll('.supplement-tooltip');
                allTooltips.forEach(tooltip => {
                    tooltip.classList.remove('visible');
                    tooltip.classList.add('hidden');
                });
            }
        };
        document.addEventListener('click', document._tooltipClickHandler);
    }
    
    console.log('🎯 All tooltip handlers attached successfully');
}
// Updated handlePackageSelection method in ZitamineQuiz class

handlePackageSelection(selectedPackageId) {
    console.log('=== PACKAGE SELECTED ===');
    console.log('Selected package:', selectedPackageId);
    
    // Show loading spinner
    this.showPackageSelectionLoader();
    
    // Hide UI elements
    if (typeof jQuery !== 'undefined') {
        jQuery(".zq-header").hide();
        jQuery(".zq-content").hide();
        jQuery(".zq-footer").hide();
    }

    const results = this.#storage.quizResults;
    let selectedPackage;

    switch(selectedPackageId) {
        case 'esential':
            selectedPackage = results.Esential;
            break;
        case 'optim':
            selectedPackage = results.Optim;
            break;
        case 'complet':
            selectedPackage = results.Complet;
            break;
        default:
            selectedPackage = results.Optim;
    }
    
    console.log('Selected package data:', selectedPackage);
    this.#storage.selectedPackageType = selectedPackageId;

    // Analytics tracking
    if (typeof gtag !== 'undefined') {
        gtag('event', 'package_selected', {
            'package_type': selectedPackageId,
            'package_total': this.calculatePackageTotal(selectedPackage),
            'supplements_count': selectedPackage?.Recommendations?.length || 0
        });
    }

    // Send package selection to backend
    this.sendPackageSelectionToBackend(selectedPackageId)
        .then(() => {
            console.log('✅ Package selection sent to backend successfully');
            
            if (selectedPackage && selectedPackage.Recommendations && selectedPackage.Recommendations.length > 0) {
                console.log('✅ Adding recommendations to cart:', selectedPackage.Recommendations);
                // THIS is where cart addition should happen (only when user selects a package)
                this.addRecommendationsToCart(selectedPackage.Recommendations);
            } else {
                console.error('❌ No recommendations found in selected package');
                this.hidePackageSelectionLoader();
                this.showUIElements();
                alert('Nu am găsit recomandări pentru pachetul selectat. Te rugăm să încerci din nou.');
            }
        })
        .catch((error) => {
            console.error('❌ Failed to send package selection to backend:', error);
            
            // Still proceed with cart addition
            if (selectedPackage && selectedPackage.Recommendations && selectedPackage.Recommendations.length > 0) {
                console.log('⚠️ Proceeding with cart addition despite backend error');
                this.addRecommendationsToCart(selectedPackage.Recommendations);
            } else {
                this.hidePackageSelectionLoader();
                this.showUIElements();
                alert('A apărut o eroare. Te rugăm să încerci din nou.');
            }
        });
}

// NEW: Show loading spinner for package selection
showPackageSelectionLoader() {
    // Create loading spinner if it doesn't exist
    if (!document.getElementById('package-selection-loader')) {
        const loaderContainer = document.createElement('div');
        loaderContainer.id = 'package-selection-loader';
        loaderContainer.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.95);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 9999;
            font-family: var(--font-body-family, Arial, sans-serif);
        `;

        const spinner = document.createElement('div');
        spinner.style.cssText = `
            width: 50px;
            height: 50px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #043B6C;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-bottom: 20px;
        `;

        const loadingText = document.createElement('div');
        loadingText.textContent = 'Se procesează selecția...';
        loadingText.style.cssText = `
            font-size: 18px;
            color: #043B6C;
            font-weight: 500;
            margin-bottom: 10px;
        `;

        const subText = document.createElement('div');
        subText.textContent = 'Adăugăm produsele în coș';
        subText.style.cssText = `
            font-size: 14px;
            color: #666;
        `;

        // Add CSS animation if not already present
        if (!document.getElementById('package-loader-styles')) {
            const style = document.createElement('style');
            style.id = 'package-loader-styles';
            style.textContent = `
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `;
            document.head.appendChild(style);
        }

        loaderContainer.appendChild(spinner);
        loaderContainer.appendChild(loadingText);
        loaderContainer.appendChild(subText);
        document.body.appendChild(loaderContainer);
    } else {
        // Show existing loader
        document.getElementById('package-selection-loader').style.display = 'flex';
    }
}

// NEW: Hide loading spinner for package selection
hidePackageSelectionLoader() {
    const loader = document.getElementById('package-selection-loader');
    if (loader) {
        loader.style.display = 'none';
    }
}

// NEW: Method to send package selection to backend
async sendPackageSelectionToBackend(packageType) {
    const testKey = this.getCurrentQuestionModel()?.TestKey;
    
    if (!testKey) {
        console.warn('No test key available for package selection');
        return;
    }

    const payload = {
        TestKey: testKey,
        PackageType: packageType
    };

    try {
        const response = await fetch('https://api.zitamine.ro/api/quiz/package/selected', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Backend response:', result);
        
        return result;
    } catch (error) {
        console.error('Error sending package selection to backend:', error);
        throw error;
    }
}
async clearCart() {
    console.log('Clearing cart before adding new items...');
    
    try {
        const response = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        
        if (response.ok) {
            console.log('✅ Cart cleared successfully');
            return true;
        } else {
            console.error('❌ Failed to clear cart:', response.status);
            return false;
        }
    } catch (error) {
        console.error('❌ Error clearing cart:', error);
        return false;
    }
}

// UPDATED: Modified addRecommendationsToCart to include package type
async addRecommendationsToCart(productRecommendations) {
    console.log('🛒 Starting to add recommendations to cart:', productRecommendations);
    
    // Clear cart first
    await this.clearCart();
    
    this.fetchAllProductSKUTable().then(async (skus) => {
        console.log('Available SKUs:', skus);
        
        const items = [];
        let missingProducts = [];
        
        for (const product of productRecommendations) {
            console.log('Processing product:', product);
            
            const skuData = skus[product.ProductCode];
            console.log(`SKU data for ${product.ProductCode}:`, skuData);
            
            if (skuData && skuData.variant_id) {
                const item = {
                    id: skuData.variant_id,
                    quantity: product.Quantity || 1,
                    properties: {
                        Recomandate: "da",
                        "Package Type": this.#storage.selectedPackageType || "unknown"
                    },
                    selling_plan: '',
                };
                items.push(item);
                console.log('Added item to cart list:', item);
            } else {
                console.warn(`No SKU found for product code: ${product.ProductCode}`);
                missingProducts.push(product.ProductCode);
                
                // Try hardcoded fallback
                const hardcodedSKUs = this.getHardcodedSKUTable();
                const hardcodedSku = hardcodedSKUs[product.ProductCode];
                
                if (hardcodedSku) {
                    const item = {
                        id: hardcodedSku.variant_id,
                        quantity: product.Quantity || 1,
                        properties: {
                            Recomandate: "da",
                            "Package Type": this.#storage.selectedPackageType || "unknown"
                        },
                        selling_plan: '',
                    };
                    items.push(item);
                    console.log('Added item using hardcoded mapping:', item);
                }
            }
        }
        
        console.log('Final items to add to cart:', items);
        console.log('Missing products:', missingProducts);
        
        if (items.length === 0) {
            console.error('No items could be mapped to cart');
            alert('Eroare: Nu am putut găsi produsele în magazin. Te rugăm să încerci din nou sau să ne contactezi.');
            this.hidePackageSelectionLoader();
            return;
        }

        if (missingProducts.length > 0) {
            console.warn('Some products could not be found:', missingProducts);
        }
        
        try {
            const result = await this.shopifyCartAdd(items);
            console.log('✅ Successfully added to cart, preparing redirect...', result);
            
            // CRITICAL FIX: Ensure testKey is available for back navigation
            let testKey = this.#storage.testKey;
            
            // If no testKey, try to get it from quiz results
            if (!testKey && this.#storage.quizResults && this.#storage.quizResults._testKey) {
                testKey = this.#storage.quizResults._testKey;
                this.#storage.testKey = testKey; // Store it
                console.log('📋 Retrieved testKey from quiz results:', testKey);
            }
            
            if (testKey) {
                console.log('💾 Using testKey for cart redirect:', testKey);
                
                // IMPORTANT: Add testKey as URL parameter for back navigation
                const cartUrl = `/cart?testKey=${encodeURIComponent(testKey)}`;
                
                // Also update browser history to support proper back navigation
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('testKey', testKey);
                
                // Update URL without reload
                history.replaceState(
                    { testKey: testKey, packageSelected: true }, 
                    '', 
                    currentUrl.toString()
                );
                
                // Add a delay to ensure cart is updated
                setTimeout(() => {
                    console.log('🔄 Redirecting to cart with back navigation support');
                    window.location.href = cartUrl;
                }, 1000);
                
            } else {
                console.warn('⚠️ No testKey available, redirecting without back navigation support');
                setTimeout(() => {
                    window.location.pathname = "/cart";
                }, 1000);
            }
            
        } catch (error) {
            console.error('❌ Failed to add items to cart:', error);
            
            this.hidePackageSelectionLoader();
            
            // Show specific error messages
            if (error.message.includes('422')) {
                alert('Unul sau mai multe produse nu sunt disponibile. Te rugăm să reîmprospătezi pagina și să încerci din nou.');
            } else {
                alert('Eroare la adăugarea produselor în coș. Te rugăm să încerci din nou.');
            }
        }
    }).catch((error) => {
        console.error('❌ Failed to fetch SKU table:', error);
        alert('Eroare la încărcarea produselor. Te rugăm să reîmprospătezi pagina.');
        this.hidePackageSelectionLoader();
    });
}

  async sendPackageSelectionToBackend(packageType) {
    const testKey = this.getCurrentQuestionModel()?.TestKey;
    
    if (!testKey) {
        console.warn('No test key available for package selection');
        return;
    }

    const payload = {
        TestKey: testKey,
        PackageType: packageType
    };

    try {
        const response = await fetch('https://api.zitamine.ro/api/quiz/package/selected', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Backend response:', result);
        
        return result;
    } catch (error) {
        console.error('Error sending package selection to backend:', error);
        throw error;
    }
}
  
getProductPrices() {
  return {
    '10010': 29.00,
    '10030': 52.00,
    '10040': 37.00,
    '20010': 24.00,
    '20040': 30.00,
    '30010': 47.00,
    '30030': 70.00,
    '30080': 26.00,
    '30090': 54.00,
    '30120': 75.00,
    '30140': 35.00,
    '30031': 70.00,
    '30150': 28.00,
    '30101': 25.00,
    '30160': 31.00,
    '30170': 106.00,
    '30190': 0.00,
    '30250': 28.00,
    '30230': 42.00,
    '30260': 55.00,
    '30310': 22.00,
    '30320': 28.00,
    '30330': 0.00,
    '30181': 96.00,
    '30051': 54.00,
    '30360': 356.00,
    '30021': 23.00,
    '30042': 52.00,
    '30061': 31.00,
    '30221': 76.00,
    '30390': 23.00,
    '30202': 44.00,
    '30211': 44.00,
    '30191': 116.00,
    '30192': 32.00,
    '20032': 39.00,
    '90011': 23.00,
    '90040': 81.00,
    '90060': 29.00,
    '90050': 29.00,
    '90020': 46.00,
    '90031': 38.00,
    '90073': 42.00,
    '20050': 23.00,

    '40100': 137.00,
    '40090': 142.00,
    '40080': 103.00,
    '40060': 138.00,
    '40140': 133.00,
    '40030': 133.00,
    '40150': 172.00,
    '40170': 134.00,
    '40160': 152.00,
    '40180': 150.00,
    '40111': 340.00,
    '30350': 315.00,
    '40041': 333.00,
    '40071': 227.00,
    '40121': 359.00,
    '40112': 266.00,
    '30231': 0.00,
    '40131': 260.00,
    '30410': 262.00,
    '40151': 285.00,
    '40210': 181.00,
    '40220': 336.00,
    '40061': 233.00,
    '321': 321.00,
    '30201': 0.00,
    '40230': 373.00,
    '40240': 287.00,
    '40250': 322.00,
    '40260': 252.00,
    '40270': 237.00,
    '50000': 410.00,
    '50010': 564.00,
    '50020': 876.00,
    '40290': 334.00,
    '40280': 188.00,
    '40300': 213.00,
    '40310': 280.00,
    '50001': 0.00,

    // Original unchanged entries below (D0001–D0087)
    'D0001': 10.00, 'D0002': 11.00, 'D0003': 12.00, 'D0004': 13.00, 'D0005': 14.00,
    'D0006': 15.00, 'D0007': 16.00, 'D0008': 17.00, 'D0009': 18.00, 'D0010': 19.00,
    'D0011': 20.00, 'D0012': 21.00, 'D0013': 22.00, 'D0014': 23.00, 'D0015': 24.00,
    'D0016': 25.00, 'D0017': 26.00, 'D0018': 27.00, 'D0019': 28.00, 'D0020': 29.00,
    'D0021': 30.00, 'D0022': 31.00, 'D0023': 32.00, 'D0024': 33.00, 'D0025': 34.00,
    'D0026': 35.00, 'D0027': 36.00, 'D0028': 37.00, 'D0029': 38.00, 'D0030': 39.00,
    'D0031': 40.00, 'D0032': 41.00, 'D0033': 42.00, 'D0034': 43.00, 'D0035': 44.00,
    'D0036': 45.00, 'D0037': 46.00, 'D0038': 47.00, 'D0039': 48.00, 'D0040': 49.00,
    'D0041': 50.00, 'D0042': 51.00, 'D0043': 52.00, 'D0044': 53.00, 'D0045': 54.00,
    'D0046': 55.00, 'D0047': 56.00, 'D0048': 57.00, 'D0049': 58.00, 'D0050': 59.00,
    'D0051': 10.00, 'D0052': 11.00, 'D0053': 12.00, 'D0054': 13.00, 'D0055': 14.00,
    'D0056': 15.00, 'D0057': 16.00, 'D0058': 17.00, 'D0059': 18.00, 'D0060': 19.00,
    'D0061': 20.00, 'D0062': 21.00, 'D0063': 22.00, 'D0064': 23.00, 'D0065': 24.00,
    'D0066': 25.00, 'D0067': 26.00, 'D0068': 27.00, 'D0069': 28.00, 'D0070': 29.00,
    'D0071': 30.00, 'D0072': 31.00, 'D0073': 32.00, 'D0074': 33.00, 'D0075': 34.00,
    'D0076': 35.00, 'D0077': 36.00, 'D0078': 37.00, 'D0079': 38.00, 'D0080': 39.00,
    'D0081': 40.00, 'D0082': 41.00, 'D0083': 42.00, 'D0084': 43.00, 'D0085': 44.00,
    'D0086': 45.00, 'D0087': 46.00
  };
}



    // NEW: Calculate supplement price based on actual product codes
calculateSupplementPrice(supplement) {
    const prices = this.getProductPrices();
    const price = prices[supplement.ProductCode];
    
    if (price === undefined) {
        console.warn(`Price not found for product code: ${supplement.ProductCode}`);
        return 30; // fallback price
    }
    
    return price;
}

    // NEW: Calculate package total
calculatePackageTotal(packageData) {
    if (!packageData || !packageData.Recommendations) return 0;
    
    return packageData.Recommendations.reduce((total, supplement) => {
        const price = this.calculateSupplementPrice(supplement);
        return total + (price * (supplement.Quantity || 1));
    }, 0);
}
filterUniquePackages(packages) {
    const seenTotals = new Set();
    const uniquePackages = [];
    
    for (const pkg of packages) {
        const total = this.calculatePackageTotal(pkg.PackageData);
        
        if (!seenTotals.has(total)) {
            seenTotals.add(total);
            uniquePackages.push(pkg);
        } else {
            console.log(`Duplicate package removed with total: ${total} Lei`);
        }
    }
    
    return uniquePackages;
}
    getNextQuestionModel() {
        return this.#nextQuestionModels.slice(-1).pop();
    }

    getCurrentQuestionModel() {
        this.#nextQuestionModels.pop();
        return this.getNextQuestionModel();
    }

    hasPrevQuestionModel() {
        return this.#nextQuestionModels.length >= 3;
    }

    getPrevQuestionModel() {
        if (!this.hasPrevQuestionModel()) {
            return this.getCurrentQuestionModel();
        }
        this.#nextQuestionModels.pop();
        this.#nextQuestionModels.pop();
        return this.getNextQuestionModel();
    }

    startOver(el = false) {
        this.#api
            .startNewQuiz(this.#storage.emailAddress, this.#storage.firstName, el)
            .then((nextQuestionModel) => {
                this.#api.nextQuestion(nextQuestionModel).then((question) => {
                    this.processQuestion(question);
                });
            });
    }

    startContinue(el = false) {
        const nextQuestionModel = this.getNextQuestionModel();
        this.#api.nextQuestion(nextQuestionModel).then((question) => {
            this.processQuestion(question);
        });
    }

    startOptionClicked(el) {
        const answer = this.getUsersAnswers();
        var profileId = 0;
        var LastFinishedQuizKey = null;
        if (el && el.getAttribute("profile")) {
            var profileId = el.getAttribute("profile");
            this.#storage.profile = profileId;
        }
        if (el && el.getAttribute("LastFinishedQuizKey")) {
            var LastFinishedQuizKey = el.getAttribute("LastFinishedQuizKey");
        }
        if (answer.AnswerIds[0] === this.#START_OPTION_RESULTS) {
            if (LastFinishedQuizKey) {
                this.#api.getResults(LastFinishedQuizKey).then((results) => {
                    this.startRecommendations(results);
                });
            }
        } else if (answer.AnswerIds[0] === this.#START_OPTION_CONTINUE) {
            this.startOver(el);
        } else if (answer.AnswerIds[0] === this.#START_OPTION_START_OVER) {
            this.startOver(el);
        } else {
            const question = {
                Id: null,
                Type: "start-options",
                Text: "Bogdan,",
                InfoText:
                    "Vrei să verifici ultima recomandare primită sau să reîncepi chestionarul?",
                ShouldStopQuiz: false,
                IsQuizOver: false,
                TestKey: null,
                Placeholder: null,
                TimeRemaining: null,
                ProgressBar: null,
                Answers: [],
                NextQuestionModel: null,
            };
            
            this.#api.checkUserStatus(this.#storage.emailAddress).then((status) => {
                if (status.Profiles.length) {
                    for (const profile of status.Profiles) {
                        if (profile.Id == profileId && profile.LastFinishedQuizKey) {
                            this.#storage.firstName = profile.Name;
                            this.#storage.profile = profile.Id;
                            question.Text = profile.Name;
                            question.Answers.push({
                                Id: this.#START_OPTION_RESULTS,
                                Text: "Vezi recomandarea existentă <span></span>",
                                Sequence: 3,
                                Profile: profileId,
                                LastFinishedQuizKey: LastFinishedQuizKey,
                            });
                            question.NextQuestionModel = status.NextQuestionModel;
                            if (typeof jQuery !== 'undefined') {
                                setTimeout(function () {
                                    jQuery("<p><span>SAU</span></p>").insertAfter(
                                        jQuery("#ZitamineQuizAnswer_2").parent()
                                    );
                                }, 1000);
                            }
                            question.Answers.push({
                                Id: this.#START_OPTION_START_OVER,
                                Text: "Începe un nou chestionar <span></span> ",
                                Sequence: 2,
                                Profile: profileId,
                                LastFinishedQuizKey: LastFinishedQuizKey,
                            });
                            question.NextQuestionModel = status.NextQuestionModel;
                        }
                    }
                }
                this.#nextQuestionModels = [];
                this.processQuestion(question);
            });
        }
    }

    nextButtonClicked(el) {
        const form = document.getElementById("ZitamineQuiz");
        if (!form.reportValidity()) {
            return;
        }

        const nextQuestionModel = this.getUsersAnswers(this.getNextQuestionModel());
        const sectionTemplate = this.#quizWrapperElement.querySelector(
            "[data-zitamine-quiz-section-template]"
        );
        const checkboxAnswers = sectionTemplate.querySelectorAll(
            "input[type=checkbox][data-zitamine-quiz-answer]:checked"
        );

        let max = el.getAttribute("max_answers");
        let min = el.getAttribute("min_answers");
        if (max && checkboxAnswers.length > max) {
            alert("Te rugăm să alegi cel mult " + max + " obiective.");
            return false;
        }
        if (min && checkboxAnswers.length < min) {
            alert("Te rugăm să alegi cel minim " + min + " obiective.");
            return false;
        }

        if (nextQuestionModel.AnsweredQuestionId === 1) {
            this.#storage.firstName = nextQuestionModel.Answer;
            if (typeof jQuery !== 'undefined') {
                jQuery(".zq-cart-objectives.page-width").hide();
                jQuery(".zq-cart-monthly--recommendation-title span").html(
                    this.#storage.firstName
                );
            }
        }

        this.#api.nextQuestion(nextQuestionModel).then((question) => {
            this.processQuestion(question);
        });
    }

    getUsersAnswers(nextQuestionModel = {}) {
        const sectionTemplate = this.#quizWrapperElement.querySelector(
            "[data-zitamine-quiz-section-template]"
        );
        const radioAnswers = sectionTemplate.querySelectorAll(
            "input[type=radio][data-zitamine-quiz-answer]:checked"
        );
        const checkboxAnswers = sectionTemplate.querySelectorAll(
            "input[type=checkbox][data-zitamine-quiz-answer]:checked"
        );
        const textAnswers = sectionTemplate.querySelector(
            "input:not([type=radio])[data-zitamine-quiz-answer]"
        );

        if (radioAnswers.length > 0 || checkboxAnswers.length > 0) {
            nextQuestionModel.AnswerIds = [];
            for (const node of radioAnswers) {
                nextQuestionModel.AnswerIds.push(parseInt(node.value));
            }
            for (const node of checkboxAnswers) {
                nextQuestionModel.AnswerIds.push(parseInt(node.value));
            }
        }

        nextQuestionModel.Answer = textAnswers?.value;
        return nextQuestionModel;
    }

    prevButtonClicked(el) {
        if (this.hasPrevQuestionModel()) {
            const nextQuestionModel = this.getPrevQuestionModel();
            if (nextQuestionModel) {
                this.#api.nextQuestion(nextQuestionModel).then((question) => {
                    this.processQuestion(question);
                });
            } else {
                this.startOver(el);
            }
        } else {
            if (typeof sessionStorage !== 'undefined') {
                const alreadyOnQEmail = sessionStorage.getItem("AlreadyOnEmailQ");
                if (alreadyOnQEmail) {
                    // Already on email question
                } else {
                    if (document.getElementById("ZitamineQuizAnswer_0") != null) {
                        this.startFromTheBeginning();
                    } else {
                        const possibleExists = sessionStorage.getItem(
                            "ZitamineQuizPrevShouldGoToEmail"
                        );
                        if (possibleExists) {
                            this.startFromTheBeginning();
                        } else {
                            this.start();
                        }
                    }
                }
            } else {
                this.startFromTheBeginning();
            }
        }
    }

    startFromTheBeginning() {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem("AlreadyOnEmailQ", "AlreadyOnEmailQ");
        }
        this.#nextQuestionModels = [];
        this.renderQuestion({
            Id: null,
            Type: "start",
            Text: "Adresa ta de e-mail este",
            InfoText: null,
            ShouldStopQuiz: false,
            IsQuizOver: false,
            TestKey: null,
            Placeholder: null,
            TimeRemaining: null,
            ProgressBar: null,
            Answers: [],
            NextQuestionModel: null,
        });
    }

    stopQuiz() {
        let shopButton =
            '<a href="https://zitamine.ro/collections/all" class="button button--primary">Vezi toate produsele <svg class="icon_arrow" style="fill: currentColor;" width="7" height="12" fill="none"><path d="M.823 0a.72.72 0 0 0-.451.147C.24.247.138.39.082.556a.94.94 0 0 0-.022.519c.042.171.131.324.255.437l4.726 4.474-4.726 4.473a.83.83 0 0 0-.211.26c-.053.102-.087.214-.099.331a.94.94 0 0 0 .029.347c.031.112.083.216.152.306s.154.161.25.213.2.08.306.084a.71.71 0 0 0 .311-.058.77.77 0 0 0 .264-.191l5.411-5.116a.85.85 0 0 0 .2-.292.93.93 0 0 0 0-.715.85.85 0 0 0-.2-.292L1.318.215C1.181.081 1.006.005.823 0h0z"></path></svg></a>';
        this.renderQuestion({
            Id: null,
            Type: "stop",
            Text: "Dragă " + this.#storage.firstName + ",",
            InfoText:
                '<p><strong>Pentru siguranța ta nu îți putem face o recomandare personalizată deoarece suplimentele alimentare pe care le iei ar trebui sa fie recomandate de un medic.</strong></p><p>Dacă ai deja o recomandare de la medicul tău, poți comanda produsele din magazinul nostru și noi ți le vom ambala în pliculețe cu doza zilnica.</p><p>Dacă te putem ajuta cu orice, dă-ne de veste la <a href="mailto:hello@zitamine.ro">hello@zitamine.ro</a>.</p>' +
                shopButton,
            ShouldStopQuiz: false,
            IsQuizOver: false,
            TestKey: null,
            Placeholder: null,
            TimeRemaining: null,
            ProgressBar: null,
            Answers: [],
            NextQuestionModel: null,
        });
    }

    stopQuizAnalizeMedicale() {
        let shopButton =
            '<a href="https://zitamine.ro/collections/all" class="button button--primary">Vezi toate produsele <svg class="icon_arrow" style="fill: currentColor;" width="7" height="12" fill="none"><path d="M.823 0a.72.72 0 0 0-.451.147C.24.247.138.39.082.556a.94.94 0 0 0-.022.519c.042.171.131.324.255.437l4.726 4.474-4.726 4.473a.83.83 0 0 0-.211.26c-.053.102-.087.214-.099.331a.94.94 0 0 0 .029.347c.031.112.083.216.152.306s.154.161.25.213.2.08.306.084a.71.71 0 0 0 .311-.058.77.77 0 0 0 .264-.191l5.411-5.116a.85.85 0 0 0 .2-.292.93.93 0 0 0 0-.715.85.85 0 0 0-.2-.292L1.318.215C1.181.081 1.006.005.823 0h0z"></path></svg></a>';
        this.renderQuestion({
            Id: null,
            Type: "stop",
            Text: "Dragă " + this.#storage.firstName + ",",
            InfoText:
                '<p><strong>Mulțumim!</strong></p> <p><strong>Vom analiza răspunsurile tale cu grijă. În formularea recomandărilor personalizate folosim atât un algoritm, cât și echipa noastră de medici și nutriționiști.</strong></p><p>Vom reveni la tine cu rezultatele în maxim două zile lucrătoare!</p><p>Dacă te putem ajuta cu orice, dă-ne de veste la <a href="mailto:hello@zitamine.ro">hello@zitamine.ro</a>.</p>' +
                shopButton,
            ShouldStopQuiz: false,
            IsQuizOver: false,
            TestKey: null,
            Placeholder: null,
            TimeRemaining: null,
            ProgressBar: null,
            Answers: [],
            NextQuestionModel: null,
        });
    }

    renderStartOptions(status) {
        const question = {
            Id: null,
            Type: "start-options",
            Text: "Bine ai revenit!",
            InfoText:
                "Am observat că ai mai completat chestionarul nostru înainte<br><span>Poți alege să adaugi un membru nou în contul tău sau să <br> reîncepi chestionarul pentru unul dintre profilele existente:<span>",
            ShouldStopQuiz: false,
            IsQuizOver: false,
            TestKey: null,
            Placeholder: null,
            TimeRemaining: null,
            ProgressBar: null,
            Answers: [],
            NextQuestionModel: null,
        };
        question.Answers.push({
            Id: this.#START_OPTION_START_OVER,
            Text: "Adaugă un membru nou în cont <span></span>",
            Sequence: 1,
            Profile: 0,
        });
        
        if (typeof jQuery !== 'undefined') {
            setTimeout(function () {
                jQuery("<p><span>SAU</span></p>").insertAfter(
                    jQuery("#ZitamineQuizAnswer_2").parent()
                );
            }, 1000);
        }
        
        if (status.Profiles.length) {
            var i = 2;
            for (const profile of status.Profiles) {
                if (profile.LastFinishedQuizKey) {
                    var profileId = profile.Id;
                } else {
                    var profileId = 0;
                }
                question.Answers.push({
                    Id: profile.Id,
                    Text: profile.Name + "<span></span>",
                    Profile: profileId,
                    LastFinishedQuizKey: profile.LastFinishedQuizKey,
                    Sequence: i,
                });
                question.NextQuestionModel = status.NextQuestionModel;
                i++;
            }
        }
        this.#nextQuestionModels = [];
        this.processQuestion(question);
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem("AlreadyOnEmailQ");
        }
    }

processQuestion(question) {
    var questions = question;
    if (!Array.isArray(questions)) {
        questions = [questions];
    }
    
    if (Array.isArray(questions) && questions.length === 1) {
        var question = questions[0];
    } else {
        this.#nextQuestionModels.push(questions[0].NextQuestionModel);
        this.fillMedicalQuestionsPage(questions);
        return;
    }

    if (question.ShouldStopQuiz) {
        this.stopQuiz();
        this.#nextQuestionModels.push(question.NextQuestionModel);
    } else if (question.IsQuizOver) {
        if(this.#uploadedFile) {
            this.stopQuizAnalizeMedicale();
            return;
        }

        // CRITICAL: Store the testKey from the completed quiz
        if (question.TestKey) {
            this.#storage.testKey = question.TestKey;
            console.log('💾 Stored testKey from completed quiz:', question.TestKey);
            
            // ALSO: Update URL with testKey immediately
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('testKey', question.TestKey);
            history.replaceState(
                { testKey: question.TestKey, quizCompleted: true }, 
                '', 
                currentUrl.toString()
            );
        }

        this.#api.getResults(question.TestKey).then((results) => {
            // ALSO store testKey in results for backup
            if (question.TestKey && results) {
                results._testKey = question.TestKey;
                this.#storage.quizResults = results;
                console.log('💾 Stored testKey in quiz results:', question.TestKey);
            }
            
            const script = document.createElement("script");
            script.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event' : 'completeaza_formularul_succes'
              });
            `;
            document.head.appendChild(script);
            
            this.startRecommendations(results);
        });
    } else {
        this.renderQuestion(question);
        this.#nextQuestionModels.push(question.NextQuestionModel);
    }
}

async addRecommendationsToCart(productRecommendations) {
    console.log('Starting to add recommendations to cart:', productRecommendations);
    
    this.fetchAllProductSKUTable().then((skus) => {
        console.log('Available SKUs:', skus);
        
        const items = [];
        let missingProducts = [];
        
        for (const product of productRecommendations) {
            console.log('Processing product:', product);
            
            const skuData = skus[product.ProductCode];
            console.log(`SKU data for ${product.ProductCode}:`, skuData);
            
            if (skuData && skuData.variant_id) {
                const item = {
                    id: skuData.variant_id,
                    quantity: product.Quantity || 1,
                    properties: {
                        Recomandate: "da",
                        "Package Type": this.#storage.selectedPackageType || "unknown"
                    },
                    selling_plan: '',
                };
                items.push(item);
                console.log('Added item to cart list:', item);
            } else {
                console.warn(`No SKU found for product code: ${product.ProductCode}`);
                missingProducts.push(product.ProductCode);
                
                // Try hardcoded fallback
                const hardcodedSKUs = this.getHardcodedSKUTable();
                const hardcodedSku = hardcodedSKUs[product.ProductCode];
                
                if (hardcodedSku) {
                    const item = {
                        id: hardcodedSku.variant_id,
                        quantity: product.Quantity || 1,
                        properties: {
                            Recomandate: "da",
                            "Package Type": this.#storage.selectedPackageType || "unknown"
                        },
                        selling_plan: '',
                    };
                    items.push(item);
                    console.log('Added item using hardcoded mapping:', item);
                }
            }
        }
        
        console.log('Final items to add to cart:', items);
        console.log('Missing products:', missingProducts);
        
        if (items.length === 0) {
            console.error('No items could be mapped to cart');
            alert('Eroare: Nu am putut găsi produsele în magazin. Te rugăm să încerci din nou sau să ne contactezi.');
            if (typeof jQuery !== 'undefined') {
                jQuery(".loader").hide();
            }
            return;
        }

        if (missingProducts.length > 0) {
            console.warn('Some products could not be found:', missingProducts);
        }
        
        this.shopifyCartAdd(items)
            .then((result) => {
                console.log('Successfully added to cart, redirecting...', result);
                
                // Add a small delay before redirect to ensure cart is updated
                setTimeout(() => {
                    window.location.pathname = "/cart";
                }, 500);
            })
            .catch((error) => {
                console.error('Failed to add items to cart:', error);
                
                // Try to get more specific error information
                if (error.message.includes('422')) {
                    alert('Unul sau mai multe produse nu sunt disponibile. Te rugăm să reîmprospătezi pagina și să încerci din nou.');
                } else {
                    alert('Eroare la adăugarea produselor în coș. Te rugăm să încerci din nou.');
                }
                
                if (typeof jQuery !== 'undefined') {
                    jQuery(".loader").hide();
                }
            });
    }).catch((error) => {
        console.error('Failed to fetch SKU table:', error);
        alert('Eroare la încărcarea produselor. Te rugăm să reîmprospătezi pagina.');
        if (typeof jQuery !== 'undefined') {
            jQuery(".loader").hide();
        }
    });
}

    async fetchQuestionTemplate(questionType) {
        const sectionName = "zitamine-quiz-question-" + questionType;
        if (this.#sectionTemplates[sectionName])
            return this.#sectionTemplates[sectionName];

        const response = await fetch("/?sections=" + sectionName);
        const json = await response.json();
        const html = json[sectionName];
        this.#sectionTemplates[sectionName] = html;
        return html;
    }

    generateId(len) {
        var arr = new Uint8Array((len || 8) / 2);
        window.crypto.getRandomValues(arr);
        return Array.from(arr, (dec) => dec.toString(16).padStart(2, "0")).join("");
    }

    // Helper method from ZitamineCommon
    handle(str) {
        return str
            .replace(/^[A-Z]/g, (str) => str.toLowerCase())
            .replace(/[A-Z][a-z]/g, (str) => "-" + str.toLowerCase())
            .replace(/A\-/g, (str) => "-" + str.toLowerCase())
            .replace(/\W+/g, "-");
    }

    // Helper method to convert data attribute names to dataset property names
    dataAttributeNameToDatasetPropertyName(str) {
        return str.replace(/^data-/g, "").replace(/-([a-z])/g, (str) => {
            return str[1].toUpperCase();
        });
    }

    // Methods for Shopify cart integration - based on original implementation
    async fetchAllProductSKUTable() {
        while (this.#productSKUTableIsLoading) {
            await this.sleep(100);
        }
        if (this.#productSKUTable !== null) return this.#productSKUTable;

        this.#productSKUTableIsLoading = true;

        const response = await fetch(
            "/collections/all?view=zitamine-quiz-skus-json"
        );
        const json = await response.json();
        this.#productSKUTable = json;

        this.#productSKUTableIsLoading = false;
        return json;
    }

    getHardcodedSKUTable() {
        // Updated with the correct product codes from your API response
        return {
            // Original products
            '20032': { variant_id: 40875471863876, product_id: 6974715265092 }, // Magneziu Bisglicinat
            '30080': { variant_id: 40875471896644, product_id: 6974715297860 }, // Spirulină naturală 450mg
            '90011': { variant_id: 40875471929412, product_id: 6974715330628 }, // Omega-3
            '10040': { variant_id: 40875471962180, product_id: 6974715363396 }, // Vitamina D3
            '90050': { variant_id: 40875471994948, product_id: 6974715396164 }, // Antiacid gastric
            
            // New products from your API response
            '30120': { variant_id: 40875472027716, product_id: 6974715428932 }, // Astaxanthin 6 mg
            '30010': { variant_id: 40875472060484, product_id: 6974715461700 }, // Bacopa natural 350mg
        };
    }

    async shopifyCartAdd(items) {
        console.log('Adding items to cart one by one:', items);
        
        // Filter out items with missing variant_id
        const validItems = items.filter(item => item.id && item.id !== undefined && item.id !== null);
        
        if (validItems.length === 0) {
            console.error('No valid items to add to cart');
            throw new Error('No valid items to add to cart');
        }

        // Add items ONE BY ONE (not in bulk) - this is the key fix
        const results = [];
        const errors = [];
        
        for (const item of validItems) {
            try {
                console.log('Adding individual item:', item);
                
                const formData = new FormData();
                formData.append('id', item.id);
                formData.append('quantity', item.quantity || 1);
                
                if (item.properties) {
                    Object.keys(item.properties).forEach(key => {
                        formData.append(`properties[${key}]`, item.properties[key]);
                    });
                }
                
                if (item.selling_plan) {
                    formData.append('selling_plan', item.selling_plan);
                }

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    const result = await response.json();
                    results.push(result);
                    console.log('Successfully added item:', result);
                } else {
                    const errorText = await response.text();
                    console.error(`Failed to add item ${item.id}:`, response.status, errorText);
                    errors.push({ item, error: errorText });
                }
            } catch (error) {
                console.error(`Error adding item ${item.id}:`, error);
                errors.push({ item, error: error.message });
            }
        }
        
        if (results.length > 0) {
            console.log(`Successfully added ${results.length} out of ${validItems.length} items:`, results);
            if (errors.length > 0) {
                console.warn('Some items failed to add:', errors);
            }
            return results;
        } else {
            console.error('Failed to add any items to cart');
            throw new Error('Failed to add any items to cart');
        }
    }
}

// Initialize the quiz when DOM is ready
(function () {
    if (document.body.matches(".template-page--ZitamineQuiz")) {
        let quizElement = document.getElementById("ZitamineQuiz");
        // Hide site header & footer only on the quiz page
if (document.body.matches(".template-page--ZitamineQuiz")) {
  const hideHeaderFooter = () => {
    const header = document.getElementById("header");
    const footer = document.getElementById("footer");
    if (header) header.style.setProperty("display", "none", "important");
    if (footer) footer.style.setProperty("display", "none", "important");
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideHeaderFooter, { once: true });
  } else {
    hideHeaderFooter();
  }
}

        window.zq = new ZitamineQuiz(quizElement);
    }
})();